import { MEASUREMENT_PROTOCOL_STEPS } from '../../config/constants';

// eslint-disable-next-line
export default {
  translation: {
    dummy: 'DE Dummy',
    misc: {
      pdfDropdown: {
        measurementProtocolPdf: 'Beratungsprotokoll PDF',
        initialAnalysis: 'Erstanalyse',
        initialAnalysisPdf: 'Erstanalyse PDF',
        checklist: 'Checkliste',
        checklistPdf: 'Checkliste PDF',
        signedProtocol: 'Unterschriebenes Beratungsprotokoll',
        downloadPdf: 'PDF Herunterladen',
        notConcluded: 'Bitte Beratungsprotokoll abschließen',
        current: 'Zwischenstand',
      },
    },
    snackbar: {
      formSubmitSuccess: 'Beratungsprotokoll erfolgreich aktualisiert!',
      formSubmitError:
        'Beratungsprotokoll konnte nicht aktualisiert werden! Auf Fehler prüfen.',
      stepError: 'Fehler im Tab',
      formFirstSubmitError: 'Beratungsprotokoll konnte nicht erstellt werden!',
      alertTitleSuccess: 'Erfolg!',
      alertTitleError: 'Achtung!',
    },
    MP: {
      yes: 'Ja',
      no: 'Nein',
      roofStructuresVisualDocumentation: 'Fotos/Videos bearbeiten',
      step: {
        [MEASUREMENT_PROTOCOL_STEPS.MARKET_DATA_REGISTER]:
          'Marktstammdatenregister',
        [MEASUREMENT_PROTOCOL_STEPS.PROPERTY]: 'Grundstück',
        [MEASUREMENT_PROTOCOL_STEPS.ROOF]: 'Dach',
        [MEASUREMENT_PROTOCOL_STEPS.ROOF_STRUCTURES]: 'Dachaufbauten',
        [MEASUREMENT_PROTOCOL_STEPS.SCAFFOLD]: 'Gerüst',
        [MEASUREMENT_PROTOCOL_STEPS.SCAFFOLD_EXPERT]:
          'Gerüst (Expertenansicht)',
        [MEASUREMENT_PROTOCOL_STEPS.ENERGY_STORAGE_AND_METER]:
          'Speicher & Zähler',
        [MEASUREMENT_PROTOCOL_STEPS.CONNECTIONS]: 'Anschlüsse',
        [MEASUREMENT_PROTOCOL_STEPS.CURRENT_CHECKLIST]: 'Checkliste AC/DC',
        [MEASUREMENT_PROTOCOL_STEPS.CONCLUSION]: 'Abschluss',
      },
      checklist: {
        progress: 'Abgeschlossene Schritte:',
      },
      expertSection: {
        dcExpertRequired:
          'Für den Abschluss der Checkliste ist eine Gerüstkostenberechnung durch einen DC-Experten erforderlich.',
        dcExpertInProgress:
          'Die Gerüstkostenberechnung durch einen DC-Experten ist in Bearbeitung.',
        dcExpertCompleted:
          'Die Gerüstkostenberechnung durch einen DC-Experten ist abgeschlossen.',
        createTask: 'DC-Experten Aufgabe erstellen',
        finishTask: 'Gerüstkostenberechnung abschließen',
        finishTaskInfo:
          'Die Gerüstkostenberechnung wird abgeschlossen und eine Benachrichtigung wird an den HV gesendet.',
        checklistIncomplete:
          'Bitte zuerst alle Schritte der Checkliste befüllen.',
      },
      dialogs: {
        filePreview: 'Dateiansicht',
        downloadFile: 'Datei herunterladen',
        downloadVideo: 'Zum Anschauen bitte das Video herunterladen',
        deleteFile: 'Datei löschen',
        editFile: 'Datei bearbeiten',
        save: 'Speichern',
        cancel: 'Abbrechen',
        namingError: 'Name konnte nicht geändert werden',
      },
      header: {
        mpCompleted: 'Beratungsprotokoll abgeschlossen',
        mpInProgress: 'Beratungsprotokoll in Arbeit',
        mpNotStarted: 'Beratungsprotokoll nicht angefangen',
      },
      // whole sales-app translation file pasted under this line
      error: {
        default: 'Etwas ist schiefgelaufen',
        noConnection: 'Keine Internetverbindung',
        permissionMic:
          'Bitte geben Sie der App die Berechtigung, das Mikrofon zu benutzen',
        permissionSpeechRecognition:
          'Bitte geben Sie der App die Erlaubnis, die Spracherkennung zu verwenden',
        permissionLocation:
          'Bitte geben Sie der App die Berechtigung, auf die Standortdaten zuzugreifen',
        userNotAllowed: 'Kontotyp inkompatibel',
        leadNotFound: 'Lead konnte nicht gefunden werden',
        contactsSync: {
          permission:
            'Bitte geben Sie der App die Berechtigung, auf Ihre Kontakte zuzugreifen',
          notFound: 'Kein Kontakt gefunden',
          deleteFailed: 'Kontakt konnte nicht gelöscht werden',
        },
        fileOpenFailed: 'Datei konnte nicht geöffnet werden.',
        fileExists:
          'Datei existiert bereits. Die Datei wird nicht hochgeladen.',
        numberNotRecognized: 'Nummer konnt nicht erkannt werden',
        photoTooBig:
          'Das ausgewählte Foto ist zu groß, es sollte kleiner als %{size} sein.',
        videoTooBig:
          'Das ausgewählte Video ist zu groß, es sollte kleiner als %{size} sein.',
        fileTooBig:
          'Die ausgewählte Datei ist zu groß, es sollte kleiner als %{size} sein.',
        fileDeleteFailed: 'Datei konnte nicht gelöscht werden.',
      },
      success: {
        signatureAdded: 'Unterschrift erfolgreich hinzugefügt!',
        numberRecognized: 'Nummer erfolgreich erkannt',
      },
      notification: {
        test: 'Test notification',
      },
      entity: {
        name: {
          CALENDAR_ENTRY: 'Termin',
          IMAGE: 'Bild',
          PHONE_NUMBER: 'Kontakt',
          ADDRESS: 'Termin',
          MAP: 'Luftbild',
          LOCAL_BINARY_FILE: 'Datei',
          MISC_FILE: 'Datei',
          NOTE: 'Notiz',
          FILE: 'Datei',
        },
        action: {
          success: {
            create: '%{entity} wurde erfolgreich erstellt',
            update: '%{entity} wurde erfolgreich bearbeitet',
            delete: '%{entity} wurde wurde erfolgreich gelöscht',
          },
          error: {
            create: '%{entity} konnte nicht erstellt werden',
            update: '%{entity} konnte nicht bearbeitet werden',
            delete: '%{entity} konnte nicht gelöscht werden',
          },
        },
      },
      validation: {
        roofRequired: 'Mindestens ein Dach muss hinzugefügt werden',
        emailOpenFail: 'E-Mail-Client konnte nicht geöffnet werden',
        endDateBeforeStartDate:
          'Der Beginn des Termins darf nicht nach seinem Ende sein',
        invalidEmailAddress: 'Ungültige E-Mail-Adresse',
        invalidPhoneNumber: 'Ungültige Telefonnummer',
        leadPhaseChangeOnlyAllowedForOpenLeads:
          'Änderung der Leadphase ist nur für offene Leads erlaubt',
        leadPhaseFillInMandatoryFields: 'Bitte die Pflichtfelder ausfüllen',
        lengthZip: 'Maximal 5 Zeichen',
        numberRequired: 'Ungültige Nummer',
        onlyIntegerNumbers: 'Nur ganzzahlige Werte',
        onlyIntegerNumberFrom1: 'Nur ganzzahlige Werte größer 0',
        onlyIntegerNumbersFrom0to5: 'Nur ganzzahlige Werte zwischen 0 und 5',
        onlyIntegerNumbersFrom1to5: 'Nur ganzzahlige Werte zwischen 1 und 5',
        onlyIntegerNumbersFrom0to10: 'Nur ganzzahlige Werte zwischen 0 und 10',
        onlyIntegerNumbersFrom1to10: 'Nur ganzzahlige Werte zwischen 1 und 10',
        onlyIntegerNumbersFrom10to30:
          'Nur ganzzahlige Werte zwischen 10 und 30',
        onlyIntegerNumbersFrom1to50: 'Nur ganzzahlige Werte zwischen 1 und 50',
        onlyIntegerNumbersFrom1to100:
          'Nur ganzzahlige Werte zwischen 1 und 100',
        onlyIntegerNumbersFrom0to100:
          'Nur ganzzahlige Werte zwischen 0 und 100',
        onlyIntegerNumbersFrom0to1000:
          'Nur ganzzahlige Werte zwischen 0 und 1000',
        onlyIntegerNumbersFrom0to2000:
          'Nur ganzzahlige Werte zwischen 0 und 2000',
        onlyIntegerNumbersFrom0to100000:
          'Nur ganzzahlige Werte zwischen 0 und 100000',
        onlyIntegerNumbersFrom0to300000:
          'Nur ganzzahlige Werte zwischen 0 und 300000',
        onlyIntegerNumbersFrom0to90: 'Nur ganzzahlige Werte zwischen 0 und 90',
        onlyNumbersFrom0to30000noDecimal:
          'Nur ganzzahlige Werte zwischen 0 und 30000',
        onlyNumbersFrom0to100000noDecimal:
          'Nur ganzzahlige Werte zwischen 0 und 100000',
        onlyNumbersFrom0to100: 'Wert muss zwischen 0 und 100 liegen',
        onlyNumbersFrom1noDecimal: 'Wert muss größer als 1 sein',
        onlyNumbersFrom10to100oneDecimal: 'Nur Werte zwischen 10,0 und 100,0',
        onlyNumbersFrom1to100oneDecimal: 'Nur Werte zwischen 1,0 und 100,0',
        onlyNumbersFrom0to100oneDecimal: 'Nur Werte zwischen 0,0 und 100,0',
        onlyNumbersFrom0to150oneDecimal: 'Nur Werte zwischen 0,0 und 150,0',
        onlyNumbersFrom0to100twoDecimal: 'Nur Werte zwischen 0,00 und 100,00',
        onlyNumbersFrom1to100twoDecimal: 'Nur Werte zwischen 1,00 und 100,00',
        onlyNumbersFrom0to1000twoDecimal: 'Nur Werte zwischen 0,00 und 1000,00',
        onlyNumbersFrom0to10000twoDecimal:
          'Nur Werte zwischen 0,00 und 10.000,00',
        onlyNumbersFrom0to100000twoDecimal:
          'Nur Werte zwischen 0,00 und 100.000,00',
        positiveNumberRequired: 'Nur positive Werte',
        required: 'Benötigt',
        atLeastOneRequired: 'Mindestens 1 benötigt',
        emptyMessage: 'Leere Nachricht ist nicht erlaubt',
        oneRequired: 'Eine Info benötigt',
        textLength: 'Maximal 50 Zeichen',
        textLengthRequired50: 'Benötigt. Maximal 50 Zeichen',
        textLengthRequired100: 'Benötigt. Maximal 100 Zeichen',
        textLengthRequired200: 'Benötigt. Maximal 200 Zeichen',
        textLengthRequired500: 'Benötigt. Maximal 500 Zeichen',
        textLength100: 'Maximal 100 Zeichen',
        textLengthNonRequired500: 'Maximal 500 Zeichen',
        textLength1500: 'Maximal 1500 Zeichen',
        validate0to100: 'Der Wert sollte zwischen 0 und 100 liegen',
        validate0to200: 'Der Wert sollte zwischen 0 und 200 liegen',
        onlyNumbersFrom10to100: 'Der Wert sollte zwischen 10 und 100 liegen',
        onlyIntegerNumbersFrom10to100:
          'Der Wert sollte zwischen 10 und 100 liegen',
        validateValueMustBeTrue: 'Benötigt',
        measurementProtocol: {
          otherHinderingRoofStructuresSelect1:
            'Eine Option muss ausgewählt werden',
          visualRepresentationInPropertyStepNeeded:
            'Zuerst Foto/Skizze im Grundstück benötigt',
          visualRepresentationAndDeliveryZoneNeeded:
            'Foto/Skizze mit Lieferzone benötigt',
          visualRepresentationNeeded: 'Foto/Skizze benötigt',
          visualDocumentationNeeded: 'Visuelle Dokumentation benötigt',
          visualRepresentationInStepsNeeded:
            'Foto/Skizze in anderen Schritten benötigt',
          visualRepresentationScaffoldNeeded:
            'Foto/Skizze und Gerüstlängen zwischen 0,00 und 100,00 benötigt',
          adjustmentsToSolarThermalSystem: 'Benötigt',
          abortMeasurementProtocol:
            'Die Anlage kann nicht gebaut werden. Das Beratungsprotokoll muss abgebrochen werden.',
          finishDrawing: 'Beenden oder löschen Sie die Zeichnung',
          corrugatedRoofSpecificType: 'Welldach muss ausgewählt sein',
          prefaRoofSpecificType:
            'Schare, Schindeln oder Sonstige muss ausgewählt sein',
          metalSpecificType: 'Falz oder Trapezblech muss ausgewählt sein',
          trapezoidalSpecificType: 'Trapezblech muss ausgewählt sein',
          generatingExistsSelect1: 'Eine Option muss ausgewählt werden',
        },
      },
      action: {
        login: 'Einloggen',
        logout: 'Logout',
        submit: 'Bestätigen',
        save: 'Speichern',
        close: 'Schließen',
        openDetails: 'Details öffnen',
        upload: 'Hochladen',
        download: 'Herunterladen',
        delete: 'Löschen',
        back: 'Zurück',
        continue: 'Fortsetzen',
        proceed: 'Weiter',
        finish: 'Fertig',
        sync: 'Jetzt Synchronisieren',
        record: 'Aufnahme starten',
        recordLimit: '(maximal eine Minute)',
        playAudio: 'Audioaufnahme abspielen',
        addDescription: 'Beschreibung angeben',
        addAudio: 'Audioaufnahme hinzufügen',
        addAddress: 'Anschrift hinzufügen',
        addPhoneNumber: 'Telefonnummer hinzufügen',
        addEmailAddress: 'E-Mail-Adresse hinzufügen',
        add: 'Hinzufügen',
        manageNotifications: 'Benachrichtigungen verwalten',
        searchAddress: 'Adresse suchen (Str., Nr., PLZ)',
        applyFilter: 'Filter anwenden',
        addSatelliteImage: 'Luftbild hinzufügen',
        showVisualRepresentation: 'Luftbild ansehen',
        select: 'Auswählen',
        edit: 'Bearbeiten',
        cancel: 'Abbrechen',
        stop: 'Stoppen',
        downloadAll: 'Alle herunterladen',
        skip: 'Überspringen',
        send: 'Senden',
      },
      title: {
        focus: 'Fokus',
        leads: 'Leads',
        activities: 'Aktivitäten',
        map: 'Karte',
        focusHeader: 'Dein Terminplan',
        leadsHeader: 'Deine Leads',
        leadDetails: 'Dein Lead',
        activitiesHeader: 'Deine Aktivitäten',
        settings: 'Einstellungen',
        audioRecorder: 'Audioaufnahme hinzufügen',
        calendarEntryDetails: 'Termin Details',
        calendarEntriesOverdue: 'Überfällige Termine',
        confirmationEmail: 'Optionale Terminbestätigung',
        emails: 'E-Mails',
        calendar: 'Kalender',
        mailbox: 'Postfach',
        info: 'Info',
        timeline: 'Zeitleiste',
        files: 'Dateien',
        fileEdit: 'Datei bearbeiten',
        addAddress: 'Ort hinzufügen',
        createCalendarEntry: 'Neuer Termin',
        noteDetails: 'Notiz Details',
        theme: 'Theme',
        lastSync: 'Zuletzt: ',
        syncing: 'Wird synchronisiert...',
        filter: 'Filter',
        leadEdit: 'Lead bearbeiten',
        calendarEntryEdit: 'Termin bearbeiten',
        noteEdit: 'Notiz bearbeiten',
        editMeasurementProtocol: 'Beratungsprotokoll bearbeiten',
        offerChecklist: 'Angebots-Checkliste',
        startMeasurementProtocol: 'Beratungsprotokoll starten',
      },
      theme: {
        device: 'Geräteeinstellung',
        light: 'Light Modus',
        dark: 'Dark Modus',
        dialogTitle: 'Theme-Einstellungen',
      },
      dialog: {
        activity: 'Aktivität',
        addOrEditSatelliteImage: 'Luftbild anlegen / ändern',
        call: 'Anrufen',
        confirm: 'Bestätigen',
        confirmLowerValue:
          'Sicher, dass die Anzahl verringert werden soll? Bestehende Daten können durch diese Aktion verloren gehen.',
        chooseFile: 'Datei auswählen',
        choosePhotos: 'Fotos auswählen',
        chooseVideos: 'Videos auswählen',
        chooseStatus: 'Status auswählen',
        choosePhotosOrVideosFromGallery: 'Aus Galerie auswählen',
        choosePhotosOrVideosFromFiles: 'Aus Dateien auswählen',
        chooseSatelliteImageAddress: 'Adresse für Luftbild auswählen',
        chooseVisualRepresentation: 'Adresse für Luftbild auswählen',
        create: 'Neu Anlegen',
        createEntry: 'Neuer Termin',
        createLead: 'Neuer Lead',
        createNote: 'Neue Notiz',
        file: 'Foto / Datei',
        message: 'Nachricht',
        distribution: 'Vertrieb',
        phone: 'Telefon',
        sms: 'SMS',
        takePhoto: 'Foto aufnehmen',
        takeVideo: 'Video aufnehmen',
        whatsApp: 'WhatsApp',
        writeMessage: 'Nachricht schreiben',
        newAddress: 'Neue Adresse',
        confirmLogoutTitle: 'Bist du sicher, dass du dich ausloggen möchtest?',
        confirmLogoutMessage:
          'Es sind Daten / Dateien vorhanden, die noch nicht erfolgreich übertragen wurden. Ein Ausloggen führt dazu, dass diese Daten / Dateien verloren gehen und neu hochgeladen werden müssen.',
        newMessage: 'Neue Interne Nachricht an Planer',
      },
      deleteDialog: {
        titleStart: 'Bist du sicher, dass du diese',
        altTitleStart: 'Bist du sicher, dass du diesen',
        titleEnd: 'löschen möchtest?',
        subtitleStart: 'Nach dem Löschen kann die',
        altSubtitleStart: 'Nach dem Löschen kann der',
        subtitleEnd:
          'nicht mehr wiederhergestellt werden. Trotzdem fortfahren?',
        address: 'Adresse',
        calendarEntry: 'Termin',
        email: 'E-Mail-Adresse',
        file: 'Datei',
        note: 'Notiz',
        phoneNumber: 'Telefonnummer',
        delete: 'löschen',
      },
      warningDialog: {
        unsavedChangesTitle:
          'Bist du sicher, dass du diese Ansicht verlassen möchtest?',
        unsavedChangesSubtitle:
          'Wenn du jetzt fortfährst, werden deine Änderungen nicht gespeichert. Möchtest du trotzdem fortfahren?',
        unsavedChangesConfirm: 'Ohne Speichern fortfahren',
        lowerValueTitle:
          'Bist du sicher, dass die Anzahl verringert werden soll?',
        lowerValueSubtitle:
          'Bestehende Daten können durch diese Aktion verloren gehen.',
        lowerValueConfirm: 'Dennoch fortfahren',
        unfinishedInitialAnalysisTitle: 'Erstanalyse abschließen',
        unfinishedInitialAnalysisSubtitle:
          'Für diesen Phasenwechsel ist eine vollständige Erstanalyse notwendig.',
        bigProjectTitle: 'Bitte Eingaben überprüfen!',
        bigProjectSubtitle: 'Ist der Lead ein Großprojekt mit ≥ 30 kWp?',
        bigProjectConfirm: 'Ja, Großprojekt speichern',
        bigProjectCancel: 'Nein',
      },
      eventButton: {
        done: 'Termin erledigt',
        overdue: 'Überfällig erledigt',
        open: 'Termin öffnen',
      },
      date: {
        name: 'Datum',
        start: 'Start',
        end: 'Ende',
        format: 'dd.MM.yyyy',
        formatShort: 'MM.yyyy',
        formatWithoutZero: 'd.M.yyyy',
        timeFormat: 'HH:mm',
        dateTimeFormat: 'dd.MM.yyyy HH:mm',
        dateTimeFormatWithSeconds: 'dd.MM.yyyy HH:mm:ss',
        today: 'Heute',
        sunday: 'Sonntag',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        allDay: 'Ganztägig',
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'So',
      },
      calendarEntry: {
        address: 'Anschrift',
        allDay: 'Ganzer Tag',
        audio: 'Audioaufnahme',
        emptyFocusSection: 'Keine Termine für diesen Tag',
        entriesForDate: 'Ihre Termine für den %{date}',
        lead: 'Lead',
        leadNotChangeable: 'Lead kann nicht geändert werden',
        nothingOverdue: 'Keine überfälligen Termine',
        overdue: 'Überfälliger Termin |||| Überfällige Termine',
        period: 'Zeitraum',
        recordButtonLimit: 'Aufnahme starten (maximal eine Minute)',
        recording: 'Aufnahme läuft (maximal eine Minute)',
        type: {
          call: 'Anruf',
          email: 'E-Mail',
          task: 'Aufgabe',
          meeting: 'Meeting',
          offerMeeting: 'Angebotsbesprechung',
          measurementMeeting: 'Aufmaß',
        },
        unknownOwner: 'Unbekannter Besitzer',
        selectAddress: 'Adresse für Termin Auswählen',
        create: 'Der Termin wurde angelegt!',
      },
      lead: {
        addAdditionalEmailAddress: 'Weitere E-Mail-Adresse hinzufügen',
        addAdditionalPhoneNumber: 'Weitere Telefonnummer hinzufügen',
        address: 'Kundenadresse',
        basicFeeElectricity: 'Licht Grundgebühr (Brutto) pro Jahr (in Euro)',
        basicFeeHeat: 'Wärme Grundgebühr (Brutto) pro Jahr (in Euro)',
        business: 'Arbeit',
        contact: 'Kontaktdaten',
        currentLocation: 'Aktueller Standort',
        customerData: 'Kundendaten',
        customerType: 'Kundentyp',
        desiredBSSCapacity: 'Gewünschter Speicher / -größe (in kWh)',
        desiredPVOutput: 'Gewünschte Leistung der Anlage (in kWp)',
        distanceGroundGutter: 'Distanz Boden-Dachrinne (in m)',
        distanceGutterRidge: 'Distanz Traufe-First (in m)',
        done: 'Erledigt',
        emptyTimeline: 'Keine Termine für diesen Lead',
        familyAndFriendsEnergyConsumption:
          'Stromverbrauch Freunde und Familie pro Jahr (in kWh)',
        heatElectricity: 'Wärme Stromverbrauch pro Jahr (in kWh)',
        heatElectricityMeterNumber: 'Wärme Stromzählernummer',
        smartHome: 'Installation Smart Home (Homematic)',
        smartHomeAnswer1: 'Kein Interesse',
        smartHomeAnswer2: 'Nur Heizkörper',
        smartHomeAnswer3: 'Nur Fußbodenheizung',
        smartHomeAnswer4: 'Heizkörper und Fußbodenheizung',
        houseElectricity: 'Licht Stromverbrauch pro Jahr (in kWh)',
        houseElectricityMeterNumber: 'Licht Stromzählernummer',
        housing: 'Immobiliendaten',
        housingDescription: 'Immobilienbezeichnung',
        idLink: 'ID Link',
        leadInfo: 'Lead Info',
        length: 'Länge',
        linkCopied: 'Link wurde kopiert!',
        loadProfile: 'Lastprofil',
        lost: 'Verloren',
        mm: 'mm',
        measurementProtocol: 'Beratungsprotokoll',
        measurementProtocolStart: 'Beratungsprotokoll starten',
        measurementProtocolContinue: 'Beratungsprotokoll fortsetzen',
        measurementProtocolShow: 'Beratungsprotokoll anzeigen',
        name: 'Kundenname',
        open: 'Offen',
        source: {
          ownLead: 'Eigener Lead',
          fairLead: 'Messe Lead',
          contactPage: 'Kontaktseite',
        },
        planned: 'Vereinbart',
        prename: 'Vorname',
        priceHeat: 'Wärme Strompreis (Brutto) pro kWh (in Cent)',
        priceLight: 'Licht Strompreis (Brutto) pro kWh (in Cent)',
        private: 'Privat',
        roofAlign: 'Dachausrichtung',
        roofPitchDegree: 'Dachneigung (in Grad)',
        roofTileCoverage: 'Ziegel-Deckmaß Länge x Breite (in mm)',
        roofTileLength: 'Ziegel-Deckmaß Länge (in mm)',
        roofTileType: 'Dachziegelart',
        roofType: 'Dachform',
        roofTileWidth: 'Ziegel-Deckmaß Breite (in mm)',
        sales: 'Vertriebler',
        salutation: 'Anrede',
        secondaryAddress: 'Abweichende Immobilienadresse',
        solarEdgeWidthM: 'Breite der Solarseite des Daches (in m)',
        surname: 'Nachname',
        title: 'Titel',
        uploaded: 'Hochgeladen',
        width: 'Breite',
        won: 'Gewonnen',
        congratulations: 'Herzlichen Glückwunsch!',
        wonALead: 'Du hast einen Lead Gewonnen',
        deleteContactPrompt: {
          question:
            'Sollen die Kontaktinformationen auf dem Gerät gelöscht werden?',
          yes: 'Ja',
          no: 'Nein',
        },
        keepUp: 'Weiter so!',
        created: 'Lead wurde erfolgreich erstellt!',
      },
      leadFileEdit: {
        title: 'Dateiname ändern',
        previousLabel: 'Bisheriger Dateiname',
        newLabel: 'Neuer Dateiname',
        currentName: 'Dataiename',
      },
      email: {
        newEmails: 'Neue E-Mail |||| Neue E-Mails',
        noNewEmails: 'Keine neuen E-Mails',
      },
      measurementProtocolSteps: {
        property: {
          headerTitle: 'Grundstück',
          title: 'Nachbargrundstück',
          aerialPhotoDeliveryZone: 'Luftbild mit Anlieferzone',
          governmentRegulation: 'Landesbauordnung',
          propertyNeighborDistanceLawsKnown:
            'Der Kunde wurde über die Vorgaben der Landesbauordnung hinsichtlich des Abstands zum Nachbargrundstück informiert.',
          propertyNeighborDistanceKept:
            'Wird Abstand zum Nachbargrundstück eingehalten?',
          plantDelivery: 'Anlagenlieferung',
          annotatedSatelliteImage: 'Luftbild mit Anlieferzone',
          yes: 'Ja',
          no: 'Nein',
          customerBearsRisk:
            'ich beauftrage trotzdem EKD mit dem Bau der Anlage. Der Auftraggeber stellt den Auftragnehmer frei und trägt das Risiko allein.',
          abortProcess: 'Anlage kann nicht gebaut werden.',
          propertyUnderMonumentalProtectionTitle: 'Denkmalschutz',
          propertyUnderMonumentalProtectionQuestion:
            'Gibt es Einschränkungen durch Denkmal- oder Ensembleschutz?',
          propertyUnderMonumentalProtectionYes:
            'der Auftraggeber übernimmt die Verantwortung über die Genehmigung durch das Denkmalschutzamt.',
          propertyUnderMonumentalProtectionAdditionalInformation:
            'Welche Einschränkungen? (ggf. Anhang hinzufügen)',
          propertyUnderMonumentalProtectionVisualDocumentation:
            'Unterlagen Denkmalschutz',
          propertyUnderMonumentalProtectionCustomerNeedsPermitKnown:
            '*Mir ist bekannt, dass ich als Auftraggeber die Verantwortung über die Genehmigung durch die zuständige Behörde und hieraus entstehende Kosten trage. ',
          deliveryZoneTitle: 'Lieferung der Anlage',
          deliveryZoneSubTitle: 'Anlieferzone',
          propertyHasDeliveryZone:
            'Steht eine Anlieferzone für 3-4 Paletten zur Verfügung?',
          markDeliveryZone: 'Bitte Anlieferzone im Luftbild markieren.',
          markPosition: 'Zum Markieren gewünschte Stelle tippen.',
          propertyHasSafeStorageFacility:
            'Ist eine sichere (Schutz vor Regen und Diebstahl) Lagermöglichkeit vorhanden?',
          googleMapsPhoto: 'Luftbild mit Google Maps',
          sketchOrDronePhoto: 'Foto von Skizze/Drohnenaufnahme',
          makeSketch: 'Skizze in der App anfertigen',
          showDeliveryZone: 'Anlieferzone anzeigen',
          editDeliveryZone: 'Anlieferzone bearbeiten',
          addDeliveryZone: 'Anlieferzone hinzufügen',
          storageFacilityVisualDocumentation: 'Lagermöglichkeit',
          storageFacilityAtGroundLevelTitle: 'Lagermöglichkeit ebenerdig',
          storageFacilityAtGroundLevel:
            'Kann die Lagermöglichkeit ebenerdig (keine starke Neigung, Bordsteinkante oder Treppe) angefahren werden?',
        },
        obstacles: {
          headerTitle: 'Hindernisse für Gerüstbau',
          addImage: 'Hausfoto hinzufügen',
          info: 'Bitte Hindernisse in der Luftbild markieren.',
          obstacles: 'Hindernisse',
          additionalCosts: 'Mehrkosten können entstehen.',
          editObstacles: 'Hindernisse bearbeiten',
          addObstacles: 'Hindernisse hinzufügen',
          showObstacles: 'Hindernisse anzeigen',
          obstaclesExist:
            'Sind Bäume/Häuser/Störobjekte vorhanden, die höher als die Dachrinne bzw. im Umkreis von maximal 20 m sind?',
          addPhotosVideos: 'Fotos/Videos hinzufügen',
          markObstacles: 'Bitte Hindernisse im Luftbild markieren.',
          tapToMark: 'Zum Markieren gewünschte Stelle tippen.',
          drawObstacles: 'Hindernisse einzeichnen',
          ventilationPipesExist: 'Sind Be- und Entlüftungsrohre vorhanden?',
          ventilationPipeRelocationByCustomerKnownCheckbox:
            'Mir ist bekannt, dass die notwendige Versetzung von Be- und Entlüftungen die für die Photovoltaik-Anlage durch den Kunden erfolgen muss. Sollte EKD die Demontage Übernehmen, entstehen zusätzliche Kosten, die dem Kunden in Rechnung gestellt werden.',
          unmentionedShadingNotPartOfOfferKnownTitle:
            'Alle nicht aufgeführten Verschattungen sind nicht Bestandteil des Angebots.',
          unmentionedShadingNotPartOfOfferKnownCheckbox:
            'Mir ist bekannt, dass alle nicht aufgeführten Verschattungen kein Bestandteil des Angebots sind.',
          radioYes: 'Ja',
          radioNo: 'Nein',
        },
        roofStructures: {
          otherHinderingRoofStructuresExist:
            'Sind weitere hinderliche Dachaufbauten vorhanden?',
          otherRoofStructuresTitle: 'Weitere Dachaufbauten',
          others: 'Sonstige',
          which: 'Welche?',
          descriptionOthers: 'Beschreibung Sonstige',
          satelliteDishExistsQuestion: 'Existiert eine Satellitenschüssel?',
          otherRoofStructuresExistQuestion: 'Existieren andere Dachaufbauten?',
          otherRoofStructuresDescription:
            'Beschreibung der anderen Dachaufbauten',
          solarThermalHindering: 'Ist Solarthermie hinderlich?',
          shouldBeDemounted: 'Soll diese durch EKD demontiert werden?',
          solarThermalHinderingAdditionalCostKnown:
            '*Mir ist bekannt, dass der für die Photovoltaik-Anlage notwendige Abbau einer Solarthermie durch den Kunden erfolgen muss. Sollte EKD die Demontage übernehmen, entstehen zusätzliche Kosten, die dem Kunden in Rechnung gestellt werden. Die Solarthermie-Flüssigkeit muss vor Demontage vom Kunden abgelassen werden.',
          flashUnit: 'Blitzschutzanlage',
          satelliteDishExists: 'Satellitenschüssel',
          otherRoofStructuresExist: 'Sonstige',
          solarThermal: 'Solarthermie',
          flashUnitExists: 'Ist ein äußerer Blitzschutz vorhanden?',
          flashUnitExistsAdditionalCostKnown:
            '*Mir ist bekannt, dass hierbei Mehrkosten für den DC-Überspannungsschutz in Höhe von 349 € anfallen.',
          removalOfRoofStructuresAdditionalCostKnown:
            '*Mir ist bekannt, dass der Abbau von Dachaufbauten, die für die Photovoltaik-Anlage entfernt werden müssen, durch den Kunden erfolgen muss. Sollte EKD die Demontage übernehmen, entstehen zusätzliche Kosten, die dem Kunden in Rechnung gestellt werden.',
        },
        roof: {
          roofRequired: 'Mindestens ein Gebäude muss hinzugefügt werden',
          linkNotOpened: 'Link konnte nicht geöffnet werden',
          erlusE58Link: 'Link zum Ziegeltyp E 58',
          erlusE58SLink: 'Link zum Ziegeltyp E 58 S',
          sonderDachTypeAdditionalCostsInfo:
            'Es entstehen Mehrkosten. Diese sind einsehbar in der EKD365+ Preisliste.',
          renovationTitle: 'Dachsanierung/Neueindeckung',
          renovationQuestion: 'Ist eine Dachsanierung/Neueindeckung geplant?',
          renovationPlannedInformation:
            'Bitte Infos zum neuen Dach (ggf. Unterlagen) und Datum der geplanten Bebaubarkeit angeben.',
          renovationPlannedVisualDocumentation: 'Unterlagen zur Dachsanierung',
          renovationPlannedInformationPlaceholder: 'Infos zum neuen Dach',
          roofTypeQuestion: 'Um welchen Dachtyp handelt es sich?',
          roofAreaVisualDocumentation: 'Foto/Video von gesamter Dachfläche',
          roofType: 'Dachtyp',
          scaffold: 'Gerüst',
          title: 'Titel',
          flatRoof: 'Flachdach',
          pitchedRoof: 'Schrägdach',
          roofTileVisualDocumentation: 'Foto/Video von Vorder- und Rückseite',
          manufacturer: 'Hersteller',
          type: 'Typ',
          roofTileWidth: 'Ziegelbreite',
          roofTileLength: 'Ziegellänge',
          tileWidthVisible: 'Ziegelbreite Sichtmaß',
          tileLengthVisible: 'Ziegellänge Sichtmaß',
          width: 'Breite',
          length: 'Länge',
          brickDimensions: 'Ziegelmaße',
          visibleDimensions: 'Sichtmaße',
          tileTypeDescription:
            'Prüfbar bei Ziegel aus Deckung, Ersatzziegel oder aus Unterlagen',
          yesWhole: 'Ja, das gesamte Dach',
          yesRidge: 'Ja, der Dachfirst ist vermörtelt',
          no: 'Nein',
          tilesMortared: 'Sind die Dachziegel vermörtelt?',
          tilesWholeRoofMortaredAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 150 € pro kWp entstehen.',
          tilesRoofRidgeMortaredAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 150 € pro kWp entstehen für Module, die im unmittelbaren Firstbereich liegen.',
          tilesUnexpectedMortaredAdditionalCostsKnown:
            '*Mir ist bekannt, falls sich im Verlauf der Dachmontage herausstellen sollte, dass wesentliche Teile der Dachziegel vermörtelt sind, Mehrkosten in Höhe von 150 € pro kWp entstehen, die vom Kunden zu tragen sind.',
          tilesScrewed: 'Sind die Dachziegel verschraubt?',
          tilesScrewedAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 150 € pro kWp entstehen.',
          tilesUnexpectedScrewedAdditionalCostsKnown:
            '*Mir ist bekannt, falls sich im Verlauf der Dachmontage herausstellen sollte, dass wesentliche Teile der Dachziegel verschraubt sind, entstehen Mehrkosten in Höhe von 150 € pro kWp, die vom Kunden zu tragen sind.',
          metalTilesDesired:
            'Sind Blechersatzziegel gewünscht?\nBei Ziegeltyp E 58 und E 58 S (Hersteller: Erlus) sind Blechersatzziegel zwingend notwendig.',
          metalTilesDesiredAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 100 € pro kWp entstehen und die Verfügbarkeit geprüft werden muss. Kosten fallen auch an für Ziegeldächer unter 20° Dachneigung.',
          substituteTilesAvailableAmount:
            'Wie viele Ersatzziegel sind schätzungsweise vorhanden?',
          requiredMeasurements: 'Notwendige Maße',
          eavesHeight: 'Traufenhöhe (Höhe Boden-Dachrinne)',
          eavesHeightPlaceholder: 'Traufenhöhe',
          amount: 'Anzahl',
          roofCoveringMetalMaterial: 'Material',
          zinc: 'Zink',
          copper: 'Kupfer',
          aluminum: 'Aluminium (Stärke ≥ 0,7mm, messbar mit Messchieber)',
          steel: 'Stahl (Stärke ≥ 0,5mm, messbar mit Messchieber)',
          metal: 'Metall',
          sonderdach: 'Sonderdach',
          roofCoveringMaterial: 'Um welches Material handelt es sich?',
          shinglesFormworkNeededKnown:
            '*Mir ist bekannt, dass eine Bebauung nur möglich ist, wenn eine Schalung vorhanden ist.',
          roofInclinationTitle: 'Dachneigung',
          flatRoofInclinationOverFourDegrees:
            'Ist die Dachneigung größer als 4°?',
          flatRoofInclinationQuestion: 'Wie groß ist die Dachneigung?',
          moreThan4: 'Mehr als 4°',
          lessThan4: '0-4°',
          metalSheet: 'Blechplatten/-scharen',
          foil: 'Folie',
          uprisingPossible: 'Eine Aufständerung ist möglich.',
          uprisingPossibleBelow10Degrees:
            'Eine Aufständerung ist möglich und empfohlen bei einer Dachneigung unter 10°',
          uprisingImPossible: 'Eine Aufständerung ist nicht möglich.',
          dcCableRoutingQuestion: 'Wie ist die DC-Kabelführung möglich?',
          onExteriorFacade: 'An Außenfassade',
          throughRoofCovering: 'Durch Dachhaut',
          dcCableRoutingVisualDocumentation: 'Foto/Video des Kabelwegs',
          dcCableRouting: 'DC-Kabelverlegung',
          storageDistance:
            'Bitte die Entfernung zwischen Hauseintritt und Speicher-/Wechselrichterstandort angeben:',
          modulesMeterSameRoof:
            'Befinden sich alle Module auf dem selben Dach, wie der Speicher/Zählerschrank?',
          modulesMeterNotSameRoofDistance:
            'Bitte Entfernung zwischen den Gebäuden angeben:',
          earthWorksPossibleKnown:
            '*Mir ist bekannt, dass ggf. Erdarbeiten notwendig sind. Diese sind vom Auftraggeber durchzuführen.',
          roofTruss: 'Dachstuhl',
          beamDimensionsTitle: 'Balkenmaße',
          roofTrussOthersVisible:
            'Dachböden, Fenster oder sichtbare Balken unter der Dachrinne vorhanden?',
          roofTrussOthersVisualDocumentation:
            'Bitte Fotos hinterlegen, die Aufschluss über den Aufbau des Dachstuhls geben könnten, wie z.B. vom Dachboden, von Fenstern oder sichtbaren Balken unter der Dachrinne.',
          roofTrussVisualDocumentation: 'Foto/Video vom Dachstuhl',
          windowExists: 'Fenster',
          windowExistsQuestion: 'Existieren Fenster?',
          extractorHoodExists: 'Dunstabzug',
          extractorHoodExistsQuestion: 'Existiert ein Dunstabzug?',
          hindering: 'Hinderlich',
          notHindering: 'Nicht hinderlich',
          hinderingQuestion: 'Ist es hinderlich?',
          radioAnswerRoofTileAttachmentMortar: 'vermörtelt',
          radioAnswerRoofTileAttachmentClamp: 'geklammert',
          radioAnswerRoofTileAttachmentGlued: 'geklebt',
          radioAnswerRoofTileAttachmentCardboardDock: 'auf Pappdocken',
          radioAnswerRoofTileAttachmentSlate: 'Kunst-/Naturschiefer',
          radioAnswerRoofTileAttachmentPantile: 'Hohlpfanne',
          mainBuilding: 'Hauptgebäude',
          buildingsCountTextBold: 'Gebäudeanzahl',
          buildingsCountText: 'Menge zu belegender Gebäude',
          flatRoofQuestion: 'Handelt es sich bei dem Dach um ein Flachdach?',
          photographTheFlatRoofAreaBeforeIndex: 'Bitte für ',
          photographTheFlatRoofAreaAfterIndex:
            ' eine Aufnahme machen, auf der die gesamte Dachfläche zu erkennen ist.',
          photographTheRoofAreaBeforeIndex:
            'Bitte eine Aufnahme machen, auf der ',
          photographTheRoofAreaAfterIndex: ' vollständig zu erkennen ist.',
          distanceGroundGutterTextBold: 'Traufenhöhe',
          distanceGroundGutter: 'Traufenhöhe (Höhe Boden-Dachrinne)',
          roofCoveringTitle: 'Dacheindeckung',
          pitchedRoofCoveringTitle: 'Dacheindeckung Schrägdach',
          flatRoofCoveringTitle: 'Dacheindeckung Flachdach',
          roofSpecificTypeTitle: 'Art',
          roofCovering: 'Um welche Art von Dacheindeckung handelt es sich?',
          brick: 'Ziegel',
          trapezoidalRoof: 'Trapezblech',
          corrugationDistance: 'Wellenabstand',
          pfettenDistance: 'Pfetten-/Lattenabstand',
          sickenDistance: 'Sickenabstand (Hochsicke zu Hochsicke)',
          sickenWidth: 'Sickenbreite',
          seamDistance: 'Falzabstand',
          seamHeight: 'Falzhöhe',
          roofCoveringTrapezoidalMaterialSize:
            'Material und Größe der Dacheindeckung',
          prefa: 'PREFA',
          prefaOrMetal: 'Metall/PREFA',
          corrugatedRoof: 'Welldach',
          fiberCementCorrugatedRoof: 'Faserzement / Wellplatten',
          corrugatedRoofInfo:
            'Unbedenklichkeitsnachweis wegen Asbest notwendig.',
          trapezoidalSheetMetal: 'Trapezblech',
          angledStandingSeam: 'Winkelstehfalz',
          doubleStandingSeam: 'Doppelstehfalz',
          roundSeam: 'Rundfalz',
          schare: 'Schare',
          shingles: 'Schindeln',
          shinglesInfo:
            'Mir ist bekannt, dass eine Bebauung nur möglich ist, wenn eine Schalung vorhanden ist.',
          shinglesBitumenFoil: 'Schindeln/Bitumen/Folie',
          thermoRoof: 'Thermodach',
          icopal: 'Icopal',
          other: 'Sonstige',
          bitumen: 'Bitumen',
          hohlpfanne: 'Hohlpfanne',
          pappdocken: 'Pappdocken',
          sonderdachType: 'Welche Art von Sonderdach?',
          sonderdachSchieferCostsKnown:
            'Mir ist bekannt, dass Mehrkosten in Höhe von 450 € pro kWp entstehen.',
          sonderdachOthersCostsKnown:
            'Mir ist bekannt, dass Mehrkosten in Höhe von 350 € pro kWp entstehen.',
          schiefer: 'Schiefer',
          roofCoveringSpecificType: 'Um welche Art handelt es sich?',
          gravel: 'Kies oder Grünfläche',
          otherRoofCovering: 'Sonstige Dacheindeckung',
          otherRoofStructures: 'Sonstige Dachaufbauten',
          whichRoofStructuresExistQuestion:
            'Welche Dachaufbauten lassen sich vorfinden?',
          roofTrussByCustomerKnown:
            'Der Dachstuhl kann nicht eingesehen werden. Der technische Dachaufbau erfolgt durch den Auftraggeber und ist diesem bekannt.',
          roofCoveringTilesLoose:
            'Die Ziegel (Dacheindeckung) sind lose gelegt?',
          roofCoveringTilesNotApparent: 'Nicht ersichtlich',
          roofCoveringAdditionalCostKnown:
            'Mir ist bekannt, dass Mehrkosten in Höhe von 150 € zzgl. MwSt. pro kWp anfallen.',
          chooseRoofTileAttachment: 'Befestigung auswählen',
          notPossible: 'Nicht möglich, ',
          brickMeasure: 'Ziegelmaß',
          brickCoverage: 'Ziegeldeckmaß (sichtbarer Teil)',
          executionSubstructure: 'Ausführung Unterkonstruktion',
          facilityCanNotBeBuilt: 'Anlage kann nicht gebaut werden:',
          addPhotoOrVideo: 'Foto-/Videodokumentation ergänzen.',
          costMayArise: 'Mehrkosten können entstehen.',
          checkboxLabel:
            'Die Arten der Ausführung für die Unterkonstruktion mit Überstand sind bekannt und zulässig.',
          roofStructureTitle: 'Dachaufbauten',
          roofStructuresExist: 'Sind andere Dachaufbauten vorhanden?',
          roofTrussVisibleBold: 'Dachstuhl',
          roofTrussVisibleQuestion: 'Kann der Dachstuhl eingesehen werden?',
          beamDimensions: 'Eingabe Balkenmaße (in cm)',
          barSpacing: 'Balkenabstand (A)',
          barWidth: 'Balkenbreite (B)',
          barHeight: 'Balkenhöhe (C)',
          beamHeightPlaceholder: 'Balkenhöhe',
          beamWidthPlaceholder: 'Balkenbreite',
          beamSpacingPlaceholder: 'Balkenabstand',
          material: 'Material',
          roofTrussBeamMaterialWood: 'Holz',
          roofTrussBeamMaterialMetal: 'Metall',
          roofTrussBeamMaterialOther: 'Sonstiges',
          broad: 'Breite',
          height: 'Höhe',
          radioYes: 'Ja',
          radioNo: 'Nein',
          enterMaterials: 'Material eingeben',
          roofSurfaces: 'Dachflächen',
          roofAmount: 'Menge zu belegender Dachflächen',
          roofAreaBold: 'Flächengröße',
          roofAreaLengthLabel: 'Länge der Dachfläche',
          roofAreaWidthLabel: 'Breite der Dachfläche',
          roofAreaTiltLabel: 'Gradzahl der Neigung',
          cableTitle: 'DC-Kabelverlegung',
          outerFacadeCable:
            'Ist eine DC-Kabelführung an der Außenfassade möglich?',
          roofSkinCable: 'Ist eine DC-Kabelführung durch die Dachhaut möglich?',
          cableLength:
            'Beträgt die DC-Kabelführung von Hauseintritt bis Speicher-/Wechselrichterstandort mehr als 10 m?',
          earthworkKnownQuestion:
            'Mir ist bekannt, dass ggf. hierbei Erdarbeiten notwendig sind. Diese sind vom Auftraggeber durchzuführen.',
          dcCableLengthTooLongAdditionalCostKnown:
            '*Mir ist bekannt, dass ab 10 m Entfernung und je 10 m Länge zwischen Hauseintritt und Speicher-/Wechselrichterstandort Mehrkosten für den DC-Überspannungsschutz in Höhe von 349 € anfallen können. ',
          aluminiumLength: 'Aluminium größer/gleich 0,7 mm Stärke',
          steelLength: 'Stahl größer/gleich 0,5 mm Stärke',
          aluminiumNotBuildable: 'Aluminium kleiner 0,7 mm Stärke',
          steelNotBuildable: 'Stahl kleiner 0,5 mm Stärke',
          pipesExist: 'Rohre',
          parapetExistsQuestion: 'Attika vorhanden?',
          parapetSizes: 'Größe (in cm)',
          parapetWidthLabel: 'Breite (a)',
          parapetHeightLabel: 'Höhe (b)',
          addBuilding: 'Gebäude hinzufügen ',
          removeBuilding: 'Gebäude entfernen',
          roofAreas: 'Dachflächen',
          addRoofArea: 'Dachfläche hinzufügen',
          removeRoofArea: 'Dachfläche entfernen',
          nestedRoof: {
            add: 'Dach hinzufügen',
            title: 'Dach',
            alternativeTitle: 'Gerüste',
            alternativeSubTitle: 'Gerüste pro Gebäude erfassen',
            scaffold: 'Gerüst',
            subTitle: 'Informationen hier ergänzen',
            alternativeAdd: 'Gerüst hinzufügen',
          },
          nestedRoofArea: {
            add: 'Dachfläche hinzufügen',
            title: 'Dachfläche',
            subTitle: 'Informationen hier ergänzen',
          },
        },
        scaffold: {
          scaffoldProvidedByEkd: 'Wird das Gerüst durch EKD gestellt?',
          scaffoldInstallationAreaVisualDocumentation:
            'Foto/Video der Aufstellfläche des Gerüstes',
          scaffoldPublicVisualDocumentation: 'Foto/Video der Zufahrt',
          distanceGroundGutter: 'Traufenhöhe (Höhe Boden-Dachrinne)',
          buildingLength: 'Gebäudelänge',
          buildingWidth: 'Gebäudebreite',
          obstaclesToScaffoldSafetyExist:
            'Sind Hindernisse (z. B. Teich, Kellertreppe, Beete, Graben) vorhanden, die einen sicheren Stand des Gerüsts verhindern?',
          obstaclesToScaffoldAdditionalCostKnown:
            '*Mir ist bekannt, dass bei vorhandenen Hindernissen wie Kellertreppe, Teich, Beete etc. zusätzliche Kosten entstehen, die vom Kunden zu tragen sind.',
          yes: 'Ja',
          no: 'Nein',
          scaffoldObstacleImageIdsSubtitle: 'Mehrkosten können entstehen.',
          scaffoldObstacleImageIdsItem: 'Fotos/Videos hinzufügen',
          buildingFacadeInsulated: 'Ist die Gebäudefassade gedämmt?',
          anchoring: 'Gerüstverankerung',
          anchoragePossiblyNeededKnown:
            '*Mir ist bekannt, dass falls die Traufhöhe mehr als vier Meter beträgt, eine Verankerung notwendig sein könnte. Die dadurch entstehenden Löcher werden nach den Arbeiten mit Stopfen verschlossen. Die Instandsetzung erfolgt ordnungsgemäß, jedoch nicht originalgetreu.',
          isScaffoldFootprintOnPublicFootpath:
            'Befindet sich die Stellfläche des Gerüsts auf öffentlichen Gehwegen?',
          isScaffoldBlockingPublicAccess:
            'Würde die Gerüstaufstellung eine öffentliche Zufahrt (wie z. B. eine Tiefgarage) blockieren?',
          scaffoldNotFromEkdConditionsKnown:
            '*Mir ist bekannt, dass der Auftraggeber zwingend ein berufsgenossenschaftskonformes (BG-konformes) Gerüst stellen muss. Bei unzureichender Gerüststellung werden die dadurch entstehenden Mehrkosten dem Auftraggeber in Rechnung gestellt. Sollte der Auftraggeber das Gerüst stellen, können längere Standzeiten durch Montageverzögerungen nicht in Rechnung gestellt werden.',
          scaffoldFromEkd: 'Wird das Gerüst durch EKD gestellt?',
          scaffoldSide: 'Auf welchen Seiten ist das Gerüst geplant?',
          markScaffolding: 'Bitte Gerüst im Luftbild markieren.',
          showScaffold: 'Gerüst anzeigen',
          editScaffold: 'Gerüst bearbeiten',
          addScaffold: 'Gerüst hinzufügen',
          markPosition: 'Zum Markieren gewünschte Stelle tippen.',
          moreNotes: 'Weitere Notizen und Hinweise für den Gerüstbauer',
          notesForScaffolder: 'Hier Notizen eingeben',
          scaffoldLengthsA: 'Länge Gerüst',
          title: 'Gerüst',
          scaffoldInstallationAreaDescription:
            'Foto oder Video der Aufstellfläche des Gerüstes',
          enterLength: 'Länge eingeben',
          permitByCustomerKnown:
            '*Mir ist bekannt, dass alle notwendigen Genehmigungen zwingend durch den Auftraggeber eingeholt werden müssen. Liegen notwendige Genehmigungen der öffentlichen Stellen zum Montagetermin nicht vor, führt dies zum Abbruch der Montage. Die Kosten für eine zweite Anfahrt trägt der Kunde.',
        },
        scaffoldExpert: {
          title: 'Gerüst (Expertenansicht)',
          externalScaffoldNecessary: 'Externes Gerüst notwendig',
          scaffoldCosts: 'Gerüstkosten',
        },
        consumption: {
          energyBillVisualDocumentation: 'Foto der Stromrechnung',
          meterVisualDocumentation: 'Foto/Video vom Zähler',
          meterTitle: 'Titel',
          meterNumber: 'Zählernummer',
          meterNumberLast4Digits: 'Die letzten 4 Ziffern der Zählernummer',
          yearlyConsumption: 'Jahresverbrauch',
          meterLocation: 'Wo befindet sich der Zähler?',
          meterLocationPlaceholder: 'Zählerstandort',
          mainElectricityMeterTitle: 'Angaben zum Hauptzähler',
          outputAndStorage: 'Leistung und Speicher',
          connectionUser: 'Anschlussnutzer',
          maloId: 'Malo-ID',
          meloId: 'Melo-ID',
          networkOperator: 'Netzbetreiber',
          meterOperator: 'Messstellenbetreiber',
          lastMeterReading: 'Letzter Zählerstand',
          propertyDesiredPvOutputKwp: 'Gewünschte Leistung der DC-Anlage',
          propertyDesiredPvOutputKwpPlaceholder: 'Leistung',
          propertyDesiredBssCapacityKwh: 'Gewünschte Speichergröße',
          propertyDesiredBssCapacityKwhPlaceholder: 'Speichergröße',
          propertyDesiredBss: 'Gewünschter Speicher',
          propertyDesiredBssPlaceholder: 'Gewünschter Speicher',
          light: 'Licht',
          electricityBill: 'Stromrechnung hochladen',
          electricityBillInfoBox: {
            title: 'Daten aus Stromrechnung lesen',
            info: 'Um den Prozess zu beschleunigen kannst du eine Stromrechnung hochladen, aus der die benötigten Angaben rausgelsen werden. Bitte stellen Sie sicher, dass es sich dabei um die aktuellste Stromrechnung handelt.',
          },
          propertyHouseElectricityConsumptionKwhPerYear:
            'Licht Stromverbrauch pro Jahr',
          propertyHouseElectricityConsumptionKwhPerYearPlaceholder:
            'Licht Stromverbrauch',
          propertyHouseElectricityPriceCentsPerKwh:
            'Licht Strompreis (Brutto) pro kWh',
          propertyHouseElectricityPriceCentsPerKwhPlaceholder:
            'Licht Strompreis',
          propertyHouseElectricityBasicFeeEuroPerYear:
            'Licht Grundgebühr (Brutto) - Jahreswert',
          propertyHouseElectricityBasicFeeEuroPerYearPlaceholder:
            'Licht Grundgebühr',
          propertyHouseElectricityMeterNumber: 'Licht Stromzählernummer',
          propertyHouseElectricityMeterNumberPlaceholder:
            'Licht Stromzählernummer',
          warmth: 'Wärme',
          propertyHeatElectricityConsumptionKwhPerYear:
            'Wärme Stromverbrauch pro Jahr',
          propertyHeatElectricityConsumptionKwhPerYearPlaceholder:
            'Wärme Stromverbrauch',
          propertyHeatElectricityPriceCentsPerKwh:
            'Wärme Strompreis (Brutto) pro kWh',
          propertyHeatElectricityPriceCentsPerKwhPlaceholder:
            'Wärme Strompreis',
          propertyHeatElectricityBasicFeeEuroPerYear:
            'Wärme Grundgebühr (Brutto) - Jahreswert ',
          propertyHeatElectricityBasicFeeEuroPerYearPlaceholder:
            'Wärme Grundgebühr',
          propertyHeatElectricityMeterNumber: 'Wärme Stromzählernummer',
          propertyHeatElectricityMeterNumberPlaceholder:
            'Wärme Stromzählernummer',
          propertyLoadprofileId: 'Lastprofil',
          private: 'Privat',
          commercial: 'Gewerblich',
          yearly: 'Jahreswert',
          monthly: 'Monatswert',
          meter: {
            add: 'Zähler hinzufügen',
            title: 'Zähler',
            subTitle: 'Informationen hier ergänzen',
            information: 'Angaben zum Zähler',
            uploadInvoice: 'Stromrechnung hochladen',
            connectionUser: 'Anschlussnutzer',
            meterNumber: 'Zählernummer',
            maloId: 'Malo-ID',
            meloId: 'Melo-ID',
            networkOperator: 'Netzbetreiber',
            yearlyConsumption: 'Jahresverbrauch',
            electricityPrice: 'Strompreis',
            measuringPointOperator: 'Messstellenbetreiber',
            lastMeterReading: 'Letzter Zählerstand',
            classification: 'Klassifizierung',
          },
        },
        conclusion: {
          areaOfResponsibility: 'Verantwortungsbereich',
          date: 'Datum',
          location: 'Ort',
          customerSignature: 'Unterschrift Kunde',
          salesSignature: 'Unterschrift Vertrieb',
          addSignature: 'Unterschrift hinzufügen',
          editSignature: 'Unterschrift bearbeiten',
          selectDate: 'Bitte Datum wählen',
          assemblyWithEkdComponentsKnown:
            'Hiermit bestätige ich, zur Kenntnis genommen zu haben, dass die Installationsunternehmen der EKD einen konformen Anschlusspunkt errichten, welcher den technischen Anschlussbedingungen des Netzbetreibers entspricht. Das beauftragte Installationsunternehmen verbaut lediglich die durch den Kunden bei der EKD erworbenen Komponenten. Das Erneuern der Bestandselektrik gehört nicht zum Leistungsumfang der Energiekonzepte Deutschland GmbH, dies obliegt dem Kunden.',
          confirmationSection: 'Bestätigung',
          comment: 'Bemerkungen',
        },
        marketDataRegister: {
          title: 'Marktstammdatenregister',
          marketDataRegisterExecutor:
            'Die Anmeldung bzw. Registrierung meiner Einheiten (PV-Anlage) im Marktstammdatenregister',
          marketDataRegisterByEkd:
            'beauftrage ich hiermit durch EKD durchführen zu lassen (empfohlen und im Angebot inkludiert).',
          marketDataRegisterByCustomer:
            'möchte ich als Kunde explizit selbst und eigenverantwortlich durchführen.',
          marketDataRegisterByCustomerAdditionalCostsKnown:
            '*Mir ist bekannt, dass wenn EKD im Laufe des Projektes in die Registrierung der Einheiten im Marktstammdatenregister eingreifen oder diese korrigieren muss, Zusatzkosten in Höhe von 200 € entstehen.',
        },
        energyStorageAndMeter: {
          meterRequired: 'Mindestens ein Zähler muss hinzugefügt werden',
          yes: 'Ja',
          no: 'Nein',
          wmsbPossible:
            'wMSB ist möglich.\nEine Prüfung, ob wMSB technisch umsetzbar ist, steht noch aus.',
          wmsbMaybePossible:
            'wMSB ist vielleicht möglich.\nEine Prüfung, ob wMSB technisch umsetzbar ist, steht noch aus.',
          wmsbNotPossible: 'wMSB ist nicht möglich',
          addMeter: 'Zähler hinzufügen',
          general: 'Allgemeine Angaben',
          general2: 'Weitere Allgemeine Angaben',
          mainMeterTitle: 'Hauptzähler',
          removeMeter: 'Zähler entfernen',
          meter: 'Zähler',
          backupPowerPackageTitle: 'Netzersatzpaket',
          add: 'hinzufügen',
          networkConnectivityTitle:
            'Messung Netzempfang am Standort des Zählers',
          mainMeterVisualDocumentation: 'Foto/Video vom Zähler',
          meterNumber: 'Zählernummer',
          energyMeterCabinetVisualDocumentation: 'Foto/Video vom Zählerschrank',
          wallBreakthroughs: 'Wanddurchbrüche',
          storageMeterVisualDocumentation: 'Foto/Video von geplantem Kabelweg',
          energyStorageLocationRequirementsMet:
            'Der Speicherstandort erfüllt die Anforderungen gem. TAB, Platz und Temperatur. Informationen sind einsehbar im Produktdatenblatt des Speichers. Ein Auszug:\n\n\u2022 Abstand zum Wasserzähler: mindestens 0,5-0,8 m (frontal)\n\u2022 Abstand zum Hausanschlusskasten: mindestens 1,2 m (frontal)\n\u2022 Abstand zum Zählerschrank: mindestens 1,2 m (frontal)\n\u2022 Mindestabstand bei Hochdruck-Gasleitung bei Kreuzungen auf 0,4 m/bei Parallelverlegungen auf 1,5 m\n\u2022 Zugang zum Raum mindestens 80 x 55 cm',
          storageMeterWallBreakthroughCount:
            'Wie viele Wanddurchbrüche sind schätzungsweise notwendig? (vom Raum des Speichers zu Zählerschrank)',
          meterLocation: 'Wo befindet sich der Zähler?',
          meterLocationPlaceholder: 'Zählerstandort',
          multilinePlaceholder: 'Bitte beschreiben',
          energyStorageAndMeterTitle: 'Speicher und Zählerschrank',
          energyStorageFloor:
            'Auf welcher Etage befindet sich der geplante Standort für den Speicher/Wechselrichter?',
          secondFloor: '2. Etage',
          firstFloor: '1. Etage',
          groundFloor: 'Erdgeschoss',
          basement: 'Keller',
          energyMeterFloor:
            'Auf welcher Etage befindet sich der bestehende Zählerschrank?',
          locationStorage: 'Standort Speicher',
          wholeStorageShouldBeVisible:
            'Gesamter Standort des Speichers muss erkennbar sein.',
          wholeMeterCabinetShouldBeVisible:
            'Gesamter Zählerschrank und Zähler sollte erkennbar sein.',
          isAtticAccessEnough:
            'Beträgt der Zugang zum Raum des Speichers mindestens 80 x 55 cm?',
          isDistanceEnough: 'Folgende Abstände werden eingehalten:',
          energyStorageWaterMeterDistanceSufficientCheckbox:
            '\u2022 Abstand zum Wasserzähler:\nmindestens 0,50 - 0,80 m (frontal)',
          energyStorageHouseConnectionBoxDistanceSufficientCheckbox:
            '\u2022 Abstand zum Hausanschlusskasten:\nmindestens 1,20 m (frontal)',
          energyStorageWaterMeterCabinetDistanceSufficientCheckbox:
            '\u2022 Abstand zum Zählerschrank:\nmindestens 1,20 m (frontal)',
          spaceRequirements: 'Die Platzanforderungen werden eingehalten:',
          standingAgainstTheWall: 'Stehend & an Wand',
          onlyOnWall: 'Nur an Wand',
          onlyStanding: 'nur stehend',
          energyMeterCabinetExists: 'Ist ein Zählerschrank vorhanden?',
          energyMeterCabinetComposition:
            'Wo/Wie ist der Zählerschrank beschaffen?',
          energyMeterCabinetCompositionPlaceholder: 'Hersteller',
          additionalCheckForNoMeterRequiredKnown:
            '*Mir ist bekannt, dass Mehrkosten entstehen und eine Prüfung der Bebauung erfolgen muss.',
          energyMeterCabinetAdditionalCostsKnown:
            '*Mir ist bekannt, dass falls die Bestandselektrik nicht der TAB entspricht aber auch kein zusätzlicher Zählerschrank verbaut werden kann (Platzprobleme o.a.) der Zählerschrank bauseits auf die geltenden TAB umgerüstet werden muss. Diese Arbeiten sind vom Kunden an den Hauselektriker zu beauftragen und enstehende Kosten kundenseitig zu tragen. Die Montage kann erst erfolgen wenn diese Vorleistung abgeschlossen ist.',
          energyStorageRequirementsHighPressureGasPipeChangeKnownCheckbox:
            'Mir ist bekannt, dass sich bei Hochdruck-Gasleitungen die Mindestabstände bei Kreuzungen auf 0,4 m /bei Parallelverlegungen auf 1,5 m vergrößern. Abstandsverringerung ist nur nach Abstimmung mit dem Beauftragten des Netzbetreibers möglich.',
          canLocationMaintainTemperature: 'Betriebstemperatur des Standorts',
          meterCabinet: 'Zählerschrank',
          freeFieldAboveMeterExists:
            'Ist oberhalb vom Zähler ein 30 cm hohes und komplett freies Feld vorhanden?',
          apzFieldOrFreeFieldInMeterCabinetExists:
            'Ist rechts unten im Zählerschrank ein  APZ-Feld bzw. ein 30 cm hohes komplett freies Feld vorhanden?',
          threePhaseSlsExists: 'Ist ein 3-phasiger SLS vorhanden?',
          flashOrSurgeProtectionExists:
            'Ist ein Blitzschutz/Überspannungsschutz unter dem Zähler vorhanden und neben dem SLS verbaut?',
          additionalMeters: 'Weitere Zähler',
          isMeterCabinetSizeEnough:
            'Ist ein Zählerschrank mit einem Mindestmaß von 60 x 110 cm verbaut?',
          count: 'Anzahl',
          grounding: 'Erdungsanlage',
          properGroundingExists: 'Ist eine ordnungsgemäße Erdung vorhanden?',
          groundingVisualDocumentation: 'Foto/Video von der Erdung',
          groundingImplementationMethod: 'Wie erfolgt die Erdung?',
          backupPowerPackageDesired: 'Ist ein Netzersatzpaket gewünscht?',
          credit: 'Gutschrift in Höhe des Netzersatzpakets',
          backupPowerPackage: 'Netzersatzpaket',
          reserveEnergyAndCredit:
            'Notstrompaket mit 3 Steckdosen (zzgl. einer Gutschrift in Höhe von 150 €)',
          backupPowerPackageAlternative: 'Alternativen:',
          backupPowerPackageMaybeNotPossibleKnown:
            '*Mir ist bekannt, dass bei der Montage meine Hauselektrik auf klassische Nullung überprüft wird. Bei Vorliegen einer klassischen Nullung kann das Netzersatzpaket nur teilumfänglich (nur ausgewählte Schaltkreise) oder gar nicht verbaut werden. Wenn gar nicht verbaut werden kann, möchte ich folgende Alternative:',
          byEkd: 'Durch die EKD',
          byCustomer:
            'Durch den Kunden bis Beginn der DC Montage (falls dies nicht erfolgt, wird die Erdung durch die EKD für 1.000 € angebracht)',
          improperGroundingAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 1.000 € entstehen können. Wenn auch bei offensichtlich vorhandener Erdung der vorgeschriebene Messwert überschritten wird, ist ggf. eine zusätzliche Erdung notwendig. Dies lässt sich erst durch eine technische Validierung feststellen, die spätestens bei der AC-Montage erfolgt.',
          isAdditionalMeterCabinetNeeded:
            'Sind zusätzliche Unter-/Zwischenzähler notwendig?',
          additionalEnergySubMetersCount:
            'Anzahl zusätzlich notwendiger Unter-/Zwischenzähler',
          isThereAnEquipotentialBondingBar:
            'Ist auch eine Potentialausgleichsschiene vorhanden?',
          notApparent: 'Nicht ersichtlich',
          meterConcept: 'Zählerkonzept',
          electricityLength: 'Ist mehr als ein Stromzähler vorhanden?',
          otherElectricityMeters:
            'Sind weitere Stromzähler über 5 kW (elektrische Ladung) vorhanden?',
          meterConceptRealizationAndAdditionalCostsKnown:
            '*Mir ist bekannt, dass die Montagefirma das Bauvorhaben laut angegebenem Zählerkonzept realisiert. Die Realisierung erfolgt unmittelbar vor dem Stromzählerwechsel durch den Netzbetreiber. Wenn der Netzbetreiber die Anwesenheit des seitens der EKD beauftragten Installationsunternehmens wünscht, ist der Auftraggeber verpflichtet, die dadurch entstandenen Mehrkosten der EKD bis zur Höhe von 350 € zzgl. MwSt. gegen Nachweis zu erstatten.',
          radioYes: 'Ja',
          radioNo: 'Nein',
          storageMountPlace:
            'Kann der Speicher/Wechselrichter im Raum des Zählerschranks montiert werden?',
          toTwoRoomsAway: '1-2 Räume entfernt',
          moreThanTwoRoomsAway: 'mehr als 2 Räume entfernt',
          isCableLengthEnough:
            'Ist eine Kabellänge zwischen Speicher und Zähler von mehr als 20 m erforderlich?',
          storageLocationVisualDocumentation:
            'Foto/Video vom gesamten Standort des Speichers',
          energyStorageAndMeterCableDistanceCostsKnownCheckbox:
            '*Mir ist bekannt, dass in den Montagekosten 25 m Kabel für den Anschluss der Systeme enthalten sind. Jegliche zusätzlichen Meter darüber hinaus werden nach der Montage in einem Arbeitsbericht festgehalten, vom Kunden bestätigt und die Kosten kundenseitig übernommen. Der Preis pro zusätzlichem Meter beträgt 50 €.',
          isThereAdditionalSpace:
            'Ist Platz für einen zusätzlichen Zählerschrank (Mindestmaß 60 x 110 cm) vorhanden?',
          inputNumber: 'Eingabe Anzahl',
          piece: 'Stück',
          yearlyConsumption: 'Jahresverbrauch',
          largeConsumer: 'Großverbraucher',
          yearlyConsumptionOverFifteenKwh:
            'Liegt der Strom-Jahresverbrauch zukünftig über 15.000 kWh?',
          yearlyConsumptionOverFifteenKwhAdditionalCostsKnown:
            'Mir ist bekannt, dass Mehrkosten in Höge von 8.900 € zzgl. MwSt. entstehen können.',
          additionalEnergySubMeterCostsKnownCheckbox:
            'Mir ist bekannt, dass Mehrkosten in Höhe von 500 € pro Stück entstehen.',
          additionalCostsForEquipotentialBondingRailKnownCheckbox:
            'Mir ist bekannt, dass Mehrkosten in Höhe von 1.000 € entstehen können. Wenn auch bei offensichtlich vorhandener Erdung der vorgeschriebene Messwert überschritten wird, ist ggf. eine zusätzliche Erdung notwendig. Dies lässt sich erst durch eine technische Validierung feststellen, die spätestens bei der AC-Montage erfolgt.',
          energyMetersCount: 'Vorhandene Stromzähler Anzahl',
          largeConsumerExists:
            'Gibt es Großverbraucher (Leistung größer 3,6 kW), die über den Zähler laufen?',
          existingGeneratingPlantExists:
            'Gibt es eine Bestandserzeugungsanlage?',
          existingGeneratingPlantExistsTitle: 'Bestandserzeugungsanlage',
          additionalHouseholdExists: 'Weiterer Haushalt',
          largeConsumerCount: 'Anzahl',
          largeConsumerPower: 'Leistung',
          largeConsumerTotalPower: 'Summe der Leistung aller Großverbraucher',
          largeConsumerName: 'Name',
          largeConsumerCount1: 'Anzahl der Großverbraucher 1',
          largeConsumerPower1: 'Leistung der Großverbraucher 1',
          largeConsumerName1: 'Name der Großverbraucher 1',
          largeConsumerCount2: 'Anzahl der Großverbraucher 2',
          largeConsumerPower2: 'Leistung der Großverbraucher 2',
          largeConsumerName2: 'Name der Großverbraucher 2',
          largeConsumerCount3: 'Anzahl der Großverbraucher 3',
          largeConsumerPower3: 'Leistung der Großverbraucher 3',
          largeConsumerName3: 'Name der Großverbraucher 3',
          largeConsumerCount4: 'Anzahl der Großverbraucher 4',
          largeConsumerPower4: 'Leistung der Großverbraucher 4',
          largeConsumerName4: 'Name der Großverbraucher 4',
          largeConsumerCount5: 'Anzahl der Großverbraucher 5',
          largeConsumerPower5: 'Leistung der Großverbraucher 5',
          largeConsumerName5: 'Name der Großverbraucher 5',
          largeConsumerNestedTitle: 'Großverbraucher',
          existingGeneratingPlantExistsQuestion:
            'Welche Bestandserzeugungsanlagen?',
          kkwExists: 'Existiert KWK (Kraft-Wärme-Kopplung)?',
          kkwExistsAdditionalCostsKnown:
            '*Mir ist bekannt, dass für die Einbindung die Errichtung einer Kaskadenschaltung notwendig wird und somit Mehrkosten in Höhe von 450 € entstehen.',
          balconyPowerPlantExists: 'Existiert Balkon-PV / Balkonkraftwerk?',
          balconyPowerPlantExistsAdditionalInfoKnown:
            '*Mir ist bekannt, dass die vorhandene Balkon-PV-Anlage bestehen bleiben, jedoch nicht ins Messkonzept integriert werden kann.',
          otherGeneratingExists: 'Existiert eine andere Erzeugungsart?',
          photovoltaicExists: 'Existiert eine Photovoltaik-Anlage?',
          photoVoltaicStorageSystemExists:
            'Ist bereits ein Speichersystem vorhanden?',
          existingPhotoVoltaicStorageSystemVisualDocumentation:
            'Foto von Typenschild des Speichers',
          existingPlantSize: 'Größe der Anlage',
          subMeterAdditionalCostsKnown:
            '*Mir ist bekannt, dass Mehrkosten in Höhe von 500 € pro Unterzähler entstehen.',
          meterRemainAdditionalCostsKnown:
            '*Mir ist bekannt, dass bei Kaskadenschaltung Mehrkosten in Höhe von 450 € entstehen.',
          inverter: 'Wechselrichter',
          electricityContractOwner: 'Wer ist der Stromvertragsinhaber',
          customer: 'Anlagenbetreiber (Kunde)',
          notCustomer: 'Nicht der Kunde',
          meterHandlingMethod: 'Was soll mit diesem Zähler passieren?',
          meterRemains: 'Zähler bleibt (Kaskadenschaltung)',
          meterRemoved: 'Zähler wird ausgebaut',
          meterRemovedAndSubMeter:
            'Zähler wird ausgebaut und ein Unterzähler wird eingebaut',
          inverterTotalPower: 'Gesamtleistung Wechselrichter',
          meterSuppliedByNewPhotovoltaicPlant:
            'Soll der Zähler mit dem Strom der neuen Photovoltaik-Anlage versorgt werden?',
          inverterCount: 'Anzahl der Wechselrichter',
          inverterType: 'Wechselrichtertyp',
          inverterType1: 'Wechselrichtertyp 1',
          inverterType2: 'Wechselrichtertyp 2',
          inverterType3: 'Wechselrichtertyp 3',
          inverterManufacturer: 'Wechselrichterhersteller',
          inverterManufacturer1: 'Wechselrichterhersteller 1',
          inverterManufacturer2: 'Wechselrichterhersteller 2',
          inverterManufacturer3: 'Wechselrichterhersteller 3',
          power1: 'Leistung 1',
          power2: 'Leistung 2',
          power3: 'Leistung 3',
          generatingPlantStartupDate: 'Inbetriebnahme Datum der Anlage',
          existingGeneratingPlantVisualDocumentation:
            'Fotos Typenschilder Bestandsanlage von jedem vorhandenen Wechselrichter-Typ',
          existingPhotovoltaicShouldBeTornDown:
            'Soll die Photovoltaik-Anlage demontiert werden?',
          shouldBeTornDown: 'Soll diese demontiert werden?',
          existingPhotovoltaicIntegratedAdditionalCostsKnown:
            '*Mir ist bekannt, dass für die Integration der Bestandsanlage Zusatzkosten in Höhe von 95 € entstehen.',
          kkw: 'Kraft-Wärme-Kopplung',
          balconyPowerPlant: 'Balkon-PV / Balkonkraftwerk',
          otherGenerating: 'andere Erzeugungsart',
          photoVoltaic: 'Photovoltaik-Anlage',
          power: 'Leistung',
          additionalHouseholdPowerKw: 'Leistung',
          businessExists: 'Gewerbe',
          businessPowerKw: 'Leistung',
          heatPumpExists: 'Wärmepumpe',
          heatPumpPowerKw: 'Leistung',
          instantaneousWaterHeaterExists: 'Durchlauferhitzer',
          instantaneousWaterHeaterPowerKw: 'Leistung',
          wallboxExists: 'Wallbox',
          wallboxPowerKw: 'Leistung',
          largeConsumerVisualDocumentation:
            'Foto Typenschild aller Großverbaucher',
          canMergeElectricityMeters:
            'Sollen alle Stromzähler auf einen Stromzähler zusammengelegt werden?',
          whichElectricityMetersAreAffected:
            'Welche Stromzähler sind betroffen?',
          energyMeterElectronicCarAffectedCheckbox: 'E-Auto',
          energyMeterPoolAffectedCheckbox: 'Pool',
          energyMeterElectronicNightStorageHeatingAffectedCheckbox:
            'Nachtspeicherheizung',
          energyMeterElectronicHeatPumpAffectedCheckbox: 'Wärmepumpe',
          energyMeterGeyserAffectedCheckbox: 'Durchlauferhitzer',
          energyMeterOtherAffectedCheckbox: 'Sonstige',
          outputPerYear: 'Leistung pro Jahr',
          sonstige: 'Sonstige',
          availableElectricityMeters: 'Welche Stromzähler sind vorhanden?',
          otherHighChargeEnergyMeterOtherHouseholdCheckbox: 'Weiterer Haushalt',
          otherHighChargeEnergyMeterBusinessCheckbox: 'Gewerbe',
          otherHighChargeEnergyMeterElectronicHeatPumpCheckbox: 'Wärmepumpe',
          otherHighChargeEnergyMeterGeyserCheckbox: 'Durchlauferhitzer',
          energyStorageSleepModeBeyondOperatingTemperatureKnownCheckbox:
            'Mir ist bekannt, dass die Empfehlung der EKD für das Aufstellen des Systems zwischen +0 °C bis +30 °C liegt und bei längerem Unter-/Überschreiten dieses Temperaturbereichs zu einer Leistungsreduzierung führt.',
          energyMeterExtraCostWhenCombinedKnownCheckbox:
            'Mir ist bekannt, dass bei einer Zusammenlegung von mehr als drei Stromzählern Mehrkosten in Höhe von 8.900 € zzgl. MwSt. entstehen.',
          energyMeterOtherUnaffectedDescription:
            'Beschreibung verbleibender Zähler',
          energyMeterOtherAffectedDescription:
            'Beschreibung weiterer Stromzähler über 5 kW',
          storageMeterCableLength:
            'Bitte die  zu verlegende Kabellänge zwischen Speicher und Zähler angeben:',
          storageMeterCableLengthPlaceholder: 'Kabellänge',
          storageMeterCableLengthAdditionalCostsKnown:
            '*Mir ist bekannt, dass die Montagekosten 25 m Kabel für den Anschluss der Systeme enthalten. Jegliche zusätzlichen Meter darüber hinaus werden nach der Montage in einem Arbeitsbericht festgehalten, vom Kunden bestätigt und die Kosten kundenseitig übernommen. Der Preis pro zusätzlichem Meter beträgt 50 €.',
          wmsbDesired:
            'Ist wMSB gewünscht? (wettbewerblicher Messstellenbetreiber)',
          networkConnectionAtMeter:
            'Messung Netzempfang am Standort des Zählers',
          bar4: '4 Balken (>-90 dBm)',
          bar3: '3 Balken (-91 bis -105 dBm)',
          bar2: '2 Balken (-106 bis -110 dBm)',
          bar1: '1 Balken (-111 bis -119 dBm)',
          noNetwork: 'kein Netz (<-120 dBm)',
          networkConnectivity: 'Welche Signalstärke wird angezeigt?',
          networkConnectivityVisualDocumentation: 'Screenshot der Signalstärke',
          networkConnectivityQuery: 'Mobilfunk-Messungs-Abfrage',
          networkConnectivityPickNumber:
            'Folgende Nummer im Telefon wählen und einen Screenshot der Signalstärke machen:',
          networkConnectivityIphone1: '\nIphone:',
          networkConnectivityIphone2: '*3001#12345#*',
          networkConnectivityAndroid1: '\nAndroid:',
          networkConnectivityAndroid2: '*#*#4636#*#*',
          testConnectivity: 'Mobilfunk testen',
        },
        currentChecklist: {
          checklist: 'Checklist',
          tapToMark: 'Zum Markieren gewünschte Stelle tippen.',
          photovoltaicSystemExists:
            'Ist bereits eine Photovoltaik-Anlage vorhanden?',
          otherPowerPlants: 'Weitere Erzeugungsanlagen',
          powerGeneratingPlantExists:
            'Sind weitere Erzeugungsanlagen vorhanden?',
          which: 'Welche?',
          solarThermalSystemExists: 'Solarthermie vorhanden?',
          wallboxDesired: 'Ist eine Wallbox gewünscht?',
          internetConnection: 'Internetanschluss',
          customerDlanExists: 'Ist D-LAN seitens des Auftraggebers vorhanden?',
          internetConnectionForEnergyStorageRequiredKnown:
            '*Mir ist bekannt, dass ein Internetanschluss (LAN) im Raum des Speichers vorhanden sein muss. Es kann zu erheblichen Störungsfällen und Servicefällen kommen, wenn keine Kabel-Internetverbindung vorliegt.',
          powerInverterManufacturer: 'Wechselrichterhersteller',
          powerInverterType: 'Wechselrichtertyp',
          powerInverterCount: 'Anzahl Wechselrichter',
          powerInverterOutput: 'Gesamtwechselrichterleistung',
          existingPhotovoltaicSystemCommissioningDate: 'Inbetriebnahme/Datum',
          existingPhotovoltaicSystemPeakOutput: 'Größe der Anlage',
          existingPhotovoltaicSystemExcessFeedIn: 'Art der Einspeisung?',
          excessFeedIn: 'Überschusseinspeisung',
          fullFeed: 'Volleinspeisung',
          existingPhotovoltaicSystemShouldGetIntegrated:
            'Soll diese in den Eigenverbrauch integriert werden?',
          existingPhotovoltaicSystemIntegrationAdditionalCostsKnown:
            'Mir ist bekannt, dass für die Integration der Bestandsanlage Zusatzkosten in Höhe von 450 € entstehen.',
          heatPump: 'Wärmepumpe',
          heatPumpSystemExists: 'Ist eine Wärmepumpe vorhanden?',
          heatPumpVisualDocumentation: 'Foto Typenschild Wärmepumpe',
          existingHeatPumpSystemShouldGetIntegrated:
            'Sollen die Voraussetzungen zur Einbindung der Wärmepumpe in das Energiemanagementsystem geschaffen werden (SG-Ready-Schnittstelle muss vorhanden sein)?',
          existingHeatPumpSystemIntegrationAdditionalCostKnown:
            '*Mir ist bekannt, dass bei der Integration einer Wärmepumpe in das Energiemanagementsystem Zusatzaufwand entsteht. Die Mehrkosten hierfür belaufen sich auf 449 € pro zu integrierendes System und sind vom Kunden zu tragen.',
          adjustmentsToHeatPumpSystemAdditionalCostKnownTitle:
            'Es fallen Zusatzkosten in Höhe von 149 € (netto) an',
          windPowerPlantExists:
            'Welche Anlagen sind vorhanden? (Achtung: Es entstehen Zusatzkosten für Integration.)',
          windkraft: 'Windkraft',
          blockheizkraftwerk: 'Blockheizkraftwerk',
          sonstiges: 'Sonstiges',
          otherPowerPlantDescription: 'Sonstiges',
          otherPowerPlantDescriptionTitle:
            'Beschreibung sonstige Erzeugungsanlagen',
          existingGeneratingPlantShouldGetMonitoringIntegratedTitle:
            'Soll die Erzeugungsanlage ins Monitoring integriert werden?',
          generatingPlantMonitoringAdditionalCostKnownTitle:
            'Es entstehen Mehrkosten in Höhe von 95 € (netto)',
          adjustmentsToSolarThermalSystemKnown:
            'Es ist dem Auftraggeber bekannt, dass der eventuelle Versatz bzw. der Rückbau inkl. Entsorgung durch den Auftraggeber geschieht.',
          infoBold: 'Bitte Wallbox im Luftbild markieren.',
          infoText: 'Zum Markieren gewünschte Stelle tippen.',
          listItem: 'Wallbox hinzufügen',
          smartHome: 'Ist eine Smart Home (Homematic) Installation gewünscht?',
          notInterested: 'Kein Interesse',
          heaterOnly: 'Nur Heizkörper',
          windowsCount: 'Anzahl der Fenster',
          heatersCount: 'Anzahl der Heizkörper',
          valvesCount: 'Anzahl der Ventile',
          photoVideoTitle: 'Foto-/Videodokumentation ergänzen.',
          photoVideoValvesSubtitle1:
            'Hersteller der Ventile muss erkennbar sein.',
          photoVideoSubtitle1: 'Hersteller muss erkennbar sein.',
          photoVideoSubtitle2:
            'Pro Verteiler soll jeweils ein Foto hinterlegt werden.',
          photoVideoLabel: 'Fotos/Videos bearbeiten',
          heatingCircuitDistributorsCount: 'Anzahl der Heizkreisverteiler',
          roomControllersCount: 'Anzahl der Raumregler',
          underfloorHeatingOnly: 'Nur Fußbodenheizung',
          heaterAndUnderfloorHeating: 'Heizkörper und Fußbodenheizung',
          distanceWallboxEnergyMeterCabinetSufficient:
            'Beträgt der Abstand zum Zählerschrank mehr als 15 m (keine Luftlinie)?',
          distanceWallboxEnergyMeterCabinetTitle:
            'Ungefähre Entfernung zum Zählerschrank',
          distanceWallboxEnergyMeterCabinet:
            'Bitte die geschätzte Entfernung zwischen Wallbox und Zählerschrank angeben:',
          distanceWallboxEnergyMeterCabinetPlaceholder: 'Entfernung',
          distanceWallboxEnergyMeterCabinetAdditionalCostsKnown:
            '*Mir ist bekannt, dass in den Montagekosten 15 m Kabel für den Anschluss der Wallbox berücksichtigt sind. Mehrmeter darüber hinaus werden bei der Montage in einem Arbeitsbericht erfasst und sind vom Kunden zu bestätigen. Die Kosten in Höhe von 50 € pro Mehrmeter sind durch den Kunden zu tragen.',
          customerDlanModel: 'Modell',
          showWallbox: 'Wallbox anzeigen',
          editWallbox: 'Wallbox bearbeiten',
          addWallbox: 'Wallbox hinzufügen',
          dlanConnectionWithPowerlineKnown:
            '*Mir ist bekannt, dass die Anbindung über einen D-LAN Powerline-Adapter erfolgt. Falls ein anderer Powerline-Adapter vorhanden ist, können ggf. Kommunikationsprobleme entstehen.',
          solarPlant: 'Photovoltaik-Anlage',
          wallbox: 'Wallbox',
          locationWallboxVisualDocumentation:
            'Foto inkl. Markierung der Wallbox',
        },
        connections: {
          general: 'Allgemeine Angaben',
          powerConnectionTypeTitle: 'Netzanschluss',
          hakTitle: 'Titel',
          houseConnectionBox: 'Hausanschlusskasten (HAK)',
          totalHakNumber:
            'Wie viele HAK befinden sich insgesamt auf dem Grundstück und im Haus?',
          hakLocation: 'Wo befindet sich der HAK?',
          atHome: 'Am Haus',
          inTheHouse: 'Im Haus',
          atThePropertyLine: 'Grundstücksgrenze',
          floor: 'Etage',
          room: 'Raum',
          addPhotoVideo: 'Foto-/Videodokumentation ergänzen.',
          photographTheFuseSize:
            'Foto/Video inkl. Nahaufnahme vom HAK mit erkennbaren Sicherungsgrößen mind. (35A)',
          editPhotoVideo: 'Fotos/Videos bearbeiten',
          hakFreelyAccessibleBeforeIndex: 'Ist HAK',
          hakFreelyAccessibleAfterIndex:
            'frei zugänglich bzw. ist Baufreiheit gegeben?',
          isHakFreelyAccessible:
            'Ist der HAK frei zugänglich bzw. ist Baufreiheit gegeben?',
          radioYes: 'Ja',
          radioNo: 'Nein',
          lineType: 'Freileitung/Erdkabel',
          whatIsTheCableType:
            'Sind Freileitungen an der Gebäudefassade oder Erdkabel vorhanden?',
          whereIsHakOneLocatedBeforeIndex:
            'Auf welcher Etage und in welchem Raum befindet sich der HAK',
          whereIsHakOneLocatedAfterIndex: '?',
          hakLocationInHouseDescription:
            'Auf welcher Etage und in welchem Raum befindet sich der HAK?',
          describe: 'Bitte beschreiben',
          earthWorksPossibleKnownCheckbox:
            'Mir ist bekannt, dass möglicherweise Erdarbeiten erfolgen müssen, die vom Auftraggeber zu leisten sind. Ein Baustart ist erst möglich, wenn die Erdarbeiten ausgeführt wurden.',
          openOnAssemblyDateKnownCheckbox:
            'Es ist dem Auftraggeber bekannt, dass der HAK am Montagetermin zugänglich und geöffnet sein muss. Mehrkosten, die ggf. anfallen können, gehen zu Lasten des Auftraggebers.',
          isolationApplicationRequiredByCustomerKnownCheckbox:
            'Mir ist bekannt, dass der Auftraggeber beim Netzbetreiber zwingend eine Isolierung für die Freileitung beantragen muss, falls diese nicht vorhanden ist. Dieser Antrag und die Umsetzung müssen unbedingt vor der Dach-Montage der Photovoltaik-Anlage erfolgen. Die Kosten für die Isolation der Freileitung trägt der Kunde.',
          additionalCostMayArise: 'Mehrkosten können entstehen.',
          undergroundCable: 'Erdkabel',
          overheadLine: 'Freileitung',
          overheadLineVisualDocumentation: 'Freileitung/Erdkabel',
          connectionTypeDialog: {
            connectionDescription:
              'Was ist der Netzanschluss?\nAm Netzanschluss übergibt der Netzbetreiber den Strom an den Kunden. Hier endet das Netz (Stromkabel) des Netzbetreibers und es beginnt das kundeneigene Stromnetz.\n',
            overheadLine: 'Freileitung',
            overheadLineDescription:
              '= über Strommasten läuft eine Stromleitung (Oberleitung) meist zum Hausgiebel des Kunden\n',
            hakDescription:
              '= der Hausanschlusskasten befindet sich meist im Haus an der Hauswand angeschraubt und darin befindet sich die Hausabsicherung mit 1-3 Sicherungen pro Wohneinheit.\n',
            hasDescription:
              '= die Hausanschlusssäule befindet sich außerhalb vom Haus und ist wie eine Säule aufgestellt. Darin befindet sich die Hausabsicherung mit 1-3 Sicherungen pro Wohneinheit.\n',
            zasDescription:
              '= eine Zähleranschlusssäule befindet sich außerhalb vom Haus und ist meist breiter als eine HAS. darin befindet sich die Hausabsicherung mit 1-3 Sicherungen pro Wohneinheit und auch der Stromzähler des Kunden.\n',
            trafoDescription:
              '= die Transformatorenstation steht meist auf dem Grundstück oder auch an der Grundstücksgrenze des Kunden.',
          },
          hakCheckDoneDuringAssemblyKnownCheckbox:
            'Mir ist bekannt, dass im Zuge der AC-Montage die Prüfung des Hausanschlusskastens erfolgt. Hier kann es in seltenen Fällen dazu kommen, dass dieser ausgetauscht/erneuert werden muss. Die Kosten gegenüber dem Netzbetreiber sind durch den Auftraggeber zu tragen.',
          distanceHakToMeterCabinet: {
            title:
              'Wie groß ist die Entfernung zwischen HAK und Zählerschrank?',
            placeholder: 'Distanz HAK-Zählerschrank',
          },
          longCableAdditionalCostKnownCheckbox:
            'Mir ist bekannt, dass in den Montagekosten 5 m Kabel vom Zählerschrank zum Netzanschluss enthalten sind. Jegliche zusätzlichen Meter darüber hinaus werden nach der Montage in einem Arbeitsbericht festgehalten, vom Kunden bestätigt und die Kosten kundenseitig übernommen. Je zusätzlichem Meter werden 50 € in Rechnung gestellt.',
          nestedHouseConnectionBox: {
            add: 'Hausanschlusskasten hinzufügen',
            title: 'Hausanschlusskasten',
            subTitle: 'Informationen hier ergänzen',
          },
          powerConnectionType: 'Welcher Netzanschluss liegt beim Kunden vor?',
          powerConnectionTypeVisualDocumentation:
            'Foto/Video des Netzanschlusses (mit erkennbaren Sicherungsgrößen, wenn keine Plombenöffnung notwendig ist)',
          powerConnectionTypeHak: 'HAK Hausanschlusskasten',
          powerConnectionTypeHas: 'HAS Hausanschlusssäule',
          powerConnectionTypeZas: 'ZAS Zähleranschlusssäule',
          powerConnectionTypeTransformer: 'Transformatorenstation',
          surface: 'Aufputz',
          flushMounted: 'Unterputz',
          hak: 'HAK',
          yesOwnProperty: 'Ja, befindet sich auf dem eigenen Grundstück.',
          freedomToBuildAndAdditionalCostsKnown:
            'Mir ist bekannt, dass der Raum zum HAK am Montagetermin zugänglich und geöffnet sein muss. Beim Netzanschluss Zähleranschlusssäule muss ein Schlüssel zur Öffnung dieser vorhanden sein. Ich stelle sicher, dass zum Zeitpunkt der Montage der Netzanschluss zugänglich ist. Alle entstehenden Mehrkosten, sollte keine Baufreiheit gegeben sein, gehen zu Lasten des Auftraggebers.',
          noNotOwnProperty:
            'Nein, befindet sich nicht auf dem eigenen Grundstück.',
          hakLocatedOnOwnProperty:
            'Befindet sich der HAK auf dem eigenen Grundstück?',
          powerConnectionMeterCabinetDistance:
            'Bitte die Entfernung zwischen Netzanschluss und Zählerschrank angeben:',
          powerConnectionNotFreeToBuildAdditionalCostsKnown:
            '*Mir ist bekannt, dass der Raum zum HAK am Montagetermin zugänglich und geöffnet sein muss. Beim Netzanschluss Zähleranschlusssäule muss ein Schlüssel zur Öffnung dieser vorhanden sein. Alle entstehenden Mehrkosten, sollte keine Baufreiheit gegeben sein, gehen zu Lasten des Auftraggebers.',
          hakMeterCabinetCablePath:
            'Wo liegen die Kabelwege zwischen HAK und Zählerschrank?',
          newCablePathsPossiblyNeededKnown:
            '*Mir ist bekannt, dass es gegebenenfalls zur Erneuerung der Kabelwege zwischen HAK und Zählerschrank kommen kann. Neue Stromleitungen werden nur Aufputz verlegt.',
          overheadLineMinimumDistanceKnown:
            'Mir ist bekannt, dass der Zugang bei Belegung zu beachten ist und mindestens ein Abstand von 0,5 m zwischen Freileitung zu Mast und Halterung vorhanden sein muss.',
          powerConnectionReplacementAdditionalCostsKnown:
            'Mir ist bekannt, dass eine Prüfung des Netzanschlusses erfolgt. Dann ist ein Antrag zur Änderung des Netzanschlusses erforderlich. Hier kann es in seltenen Fällen dazu kommen, dass dieser ausgetauscht/erneuert werden muss. Die Kosten gegenüber dem Netzbetreiber sind durch den Auftraggeber zu tragen.',
          powerConnectionLocation: 'Wo befindet sich der Netzanschluss?',
          powerConnectionReplacementResponsibleParty:
            'Im Falle einer notwendigen Änderung des Netzanschlusses',
          powerConnectionReplacementResponsiblePlantOperator:
            'führe ich die Beantragung als Anlagenbetreiber selbst durch.',
          powerConnectionReplacementResponsibleEkd:
            'soll diese durch die EKD erfolgen (Kosten für administrativen Aufwand betragen 95 €).',
          atBuilding: 'Am Haus',
          atPropertyBorder: 'An der Grundstücksgrenze',
          zasAndHas: 'ZAS (Zähleranschlusssäule) und HAS (Hausanschlusssäule)',
          powerConnectionAtBorderAdditionalActionKnown:
            '*Mir ist bekannt, dass möglicherweise Erdarbeiten erfolgen müssen, die vom Auftraggeber zu leisten sind. Ein Baustart ist erst möglich, wenn die Erdarbeiten ausgeführt wurden.',
        },
      },
      note: {
        assignedSales: 'zugeordneter Sales',
        calendarEntryType: 'Termintyp',
        description: 'Beschreibung',
        dropdown: 'Dropdown',
        information: 'Informationen',
        leadNotChangeable: 'Lead kann nicht geändert werden',
        management: 'Management',
        noteType: 'Notiztyp',
        selectLead: 'Lead auswählen',
        type: {
          note: 'Notiz',
          closeNote: 'Notiz, um Termin zu erledigen',
          reopenNote: 'Notiz, um Termin zu öffnen',
          minuteCall: 'Anrufprotokoll',
          minuteMeeting: 'Meetingprotokoll',
        },
        relatedCalendarEntry: 'Zugehöriger Termin',
        created: 'Notiz wurde erfolgreich erstellt!',
      },
      leads: {
        leadsFromMyLeads: 'Leads aus "Meine Leads"',
        myLeads: 'Meine Leads',
        searchMyLeads: 'Meine Leads durchsuchen…',
        nearMe: 'Meine offenen Leads in der Nähe',
        noNearLeads: 'Keine Leads in der Nähe',
      },
      leadPhase: {
        all: 'Alle',
        callLater: 'Später anrufen',
        delay: 'Verzögerung',
        firstContact: 'Erstkontakt',
        leadFrom: 'Leads aus',
        leads: 'Leads',
        measureDate: 'Aufmaßtermin',
        myLeads: 'Meine Leads',
        notReached: 'Keinen Erreicht',
        offerDone: 'Angebot fertig',
        offerInProcess: 'Angebot in Bearbeitung',
        offerMeeting: 'Angebotsbesprechung',
        searchMyLeads: 'Meine Leads durchsuchen…',
        worth: 'Wert',
      },
      login: {
        about: 'Impressum',
        privacyProtection: 'Datenschutz',
        welcome: 'Willkommen',
      },
      filter: {
        sort: 'Sortierung der Leads',
        allEntries: 'Alle Einträge',
        onlyCalls: 'Anruf',
        onlyEmails: 'E-Mail',
        onlyTasks: 'Aufgabe',
        onlyMeeting: 'Meeting',
        onlyMeasurementMeeting: 'Aufmaß',
        allTime: 'Gesamte Zeit',
        today: 'Heute',
        me: 'Ich',
        other: 'Andere Sales',
        surname: 'Nachname: A-Z',
        surnameDsc: 'Nachname: Z-A',
        createdAt: 'Aktivität: Alt-Neu',
        createdAtDsc: 'Aktivität: Neu-Alt',
        entryType: 'Aktivitätsart',
        time: 'Zeitraum',
        owner: 'Vertriebler',
        searchOwner: 'Vertriebler durchsuchen...',
        onlyImages: 'Nur Bilder',
        onlyFiles: 'Nur Dateien',
        urgent: 'Überfällig',
        state: 'Status',
        all: 'Alles',
        allMember: 'Ganzes Team',
        searchUsers: 'Suche nach Sales',
        fileType: 'Dateityp',
      },
      imageCategories: {
        noCategory: 'Nicht kategorisiert',
        roofBuilding: 'Dach/Gebäude',
        energyMeter: 'Zählerschrank/Zähler',
        locationStorage: 'Standort Speicher/Innenraum',
        locationWallbox: 'Standort Wallbox/Kabelverlegung',
        houseConnectionBox: 'Hausanschlusskasten (HAK)',
        obstacle: 'Hindernis',
        scaffoldObstacle: 'Gerüst Hindernis',
        scaffoldPublicObstacle: 'Gerüst Öffentliches Hindernis',
        storageMeter: 'Speicherzähler',
        meterCabinet: 'Zählerschrank',
        spaceForAdditionalEnergyMeterCabinet:
          'Platz für einen zusätzlichen Zählerschrank ',
        valve: 'Ventile',
        heatingCircuitDistributor: 'Heizkreisverteiler',
        roomController: 'Raumregler',
        roofArea: 'Dachfläche',
        flatRoof: 'Flachdach',
        roofStructures: 'Dachaufbauten',
        overheadLine: 'Freileitung',
        dcCableRoutingAlongOutsideFacade: 'DC-Kabelführung Außenfassade',
        dcCableRoutingAlongRoofCladding: 'DC-Kabelführung Dachhaut',
        storageFacilityAtGroundLevel: 'Lagermöglichkeit ebenerdig',
        bondingRail: 'Poti-Schiene',
        videoMessage: 'Lead Video Nachricht',
        planningMessage: 'Planernachricht',
        planningTask: 'Planungsaufgabe',
        flashUnit: 'Blitzschutzanlage',
        overheadLineUndergroundCable: 'Freileitung/Erdkabel',
        scaffoldInstallationArea: 'Gerüst Aufstellfläche',
        meterLocation: 'Zählerstandort',
        grounding: 'Erdung',
        heatPump: 'Wärmepumpe',
        dcCableRouting: 'DC-Kabelführung',
        undergroundCable: 'Erdkabel',
        mainMeter: 'Hauptzähler',
        brick: 'Ziegel',
        roofRenovation: 'Unterlagen Dachsanierung',
        roofTrussOthers: 'Dachstuhl Sonstiges',
        largeConsumer: 'Typenschild Großverbraucher',
        storageLocation: 'Standort Speicher',
        storageFacility: 'Lagermöglichkeit',
        monumentProtection: 'Einschränkungen',
        networkConnectivity: 'Netzempfang',
        roofTruss: 'Dachstuhl',
        storageMeterCableRoute: 'Kabelweg Speicher Zähler',
        powerConnectionType: 'Netzanschluss',
        existingGeneratingPlant: 'Bestandsanlage',
        existingPhotoVoltaicStorageSystem:
          'Bestands-Speichersystem Solaranlage',
      },
      timelineDoneFilter: {
        allEntries: 'Alle Einträge',
        onlyCalendarEntries: 'Nur Termine',
        onlyNotes: 'Nur Notizen',
        onlyMessages: 'Nur interne Nachrichten',
      },
      addressSelect: {
        selectedAddress: 'Ausgewählte Adresse',
        manualEntry: 'Zur manuellen Eingabe',
        autocompleteEntry: 'Zur automatischen Eingabe',
        street: 'Straße',
        number: 'Nr.',
        zip: 'PLZ',
        locality: 'Ort',
        country: 'Land',
        minSearch: '- Mindestens 5 Buchstaben -',
      },
      labelListItem: {
        mobile: 'Mobil',
        private: 'Privat',
        work: 'Arbeit',
        placeholderPhoneNumber: 'Telefonnummer angeben',
        placeholderEmailAddress: 'E-Mail-Adresse eingeben',
      },
      satelliteImage: {
        savePhoto: 'Foto nur speichern',
        addDrawing: 'Zeichnung hinzufügen',
        addText: 'Fügen Sie einen Text hinzu',
        addTextPlaceholder: 'Schreiben, dann Karte klicken',
        image: 'Luftbild',
        removeAllLines: 'alle Linien entfernen',
        removeAllTexts: 'alle Texte entfernen',
        satelliteImageAdded: 'Satellitenbild wurde erfolgreich erstellt!',
        satelliteImageUpdated: 'Satellitenbild wurde erfolgreich bearbeitet!',
      },
      imageFile: {
        image: 'Bild',
        photo: 'Foto',
        satelliteImage: 'Luftbild',
        customImage: 'Luftbild',
        sketch: 'Skizze',
        of: 'vom',
        changeCategory: 'Kategorie ändern',
        chooseCategory: 'Kategorie wählen',
      },
      misc: {
        of: 'von',
        done: 'erledigt',
        description: 'Beschreibung',
        optional: 'optional',
        s2tUnavailable: 'Speech-To-Text ist nicht verfügbar',
        information: 'Informationen',
        details: 'Details',
        status: 'Status',
        version: 'Version',
        app: 'App',
        amount: 'Anzahl',
        unspecified: 'Nicht angegeben',
        search: 'Leads durchsuchen...',
        unkownTeam: 'Unbekanntes Team',
        searchSales: 'Sales suchen',
        notYetAvailable: 'Noch nicht verfügbar',
        empty: 'leer',
        linkToMiddleware: 'Bitte melden sie sich in der Leads-Middleware an',
        relatedLead: 'Zugehöriger Lead',
        appUpdateInfo: 'Neue App-Version ist verfügbar',
        downloadUpdate: 'Klicken Sie hier, um die Anwendung zu aktualisieren',
        toggleAnimationGif: 'Glückwunsch-Animation bei gewonnenen Leads',
        changesSaved: 'Änderungen erfolgreich gespeichert.',
        moreInfo: 'Mehr Info',
        shouldSaveAllLeadsToContacts:
          'Kontakte für alle eigenen offenen Leads erstellen',
      },
      measurementProtocol: {
        yes: 'Ja',
        no: 'Nein',
        comment: 'Kommentar',
        addPhotoVideo: 'Foto/Video hinzufügen',
        addPhoto: 'Foto hinzufügen',
        invalidImageType: 'Ungültiger Dateityp ausgewählt',
        imageUploadError: 'Fehler beim Hoachladen der Datei',
        editPhotosVideos: 'Fotos/Videos bearbeiten',
        addPhotosVideos: 'Fotos/Videos hinzufügen',
        showPhotosVideos: 'Fotos/Videos anzeigen',
        addVisualDocumentation: 'Bitte Foto-/Videodokumentation ergänzen',
        addVisualDocumentationReadOnly: 'Foto-/Videodokumentation',
        additionalCosts: 'Mehrkosten können entstehen.',
        itemPlaceholder: 'Standort Wallbox/Kabelverlegung',
        next: 'Weiter',
        goToHomeScreen: 'Zurück zur Startseite',
        neighboringProperty: 'Nachbargrundstück',
        governmentRegulationsSpecifications:
          'Die Vorgaben der Landesbauordnung sind hinsichtlich des Abstands zum Nachbargrundstück bekannt.',
        isTheDistanceKept: 'Wird Abstand zum Nachbargrundstück eingehalten?',
        facilityCannotBeBuilt:
          'Die Anlage kann nicht gebaut werden. Das Beratungsprotokoll muss abgebrochen werden.',
        initialAnalysis: 'Nur Erstanalysebogen ausgeben?',
        initialAnalysisProgressIndicatorNotFinished:
          'Erstanalyse in Bearbeitung',
        initialAnalysisProgressIndicatorFinished:
          'Erstanalyse in erfolgreich abgeschlossen',
        inDistanceFromTheNeighbour:
          'Die Vorgaben der Landesbauordnung sind hinsichtlich des Abstands zum Nachbargrundstück bekannt.',
        measurementItems: {
          marketDataRegister: 'Marktstammdatenregister',
          conclusion: 'Abschluss',
          connection: 'Anschlüsse',
          checklist: 'Checkliste AC/DC',
          roof: 'Dach',
          roofStructures: 'Dachaufbauten',
          scaffold: 'Gerüst',
          scaffoldExpert: 'Gerüst (Expertenansicht)',
          property: 'Grundstück',
          obstacle: 'Hindernisse',
          storage: 'Speicher & Zähler',
          energyStorageAndMeter: 'Speicher & Zähler',
        },
        visualRepresentation: {
          title: 'Luftbild / Skizze',
          add: 'Luftbild/Skizze hinzufügen',
          edit: 'Luftbild/Skizze bearbeiten',
          provide:
            'An dieser Stelle bitte ein repräsentatives Luftbild anfertigen oder eine Skizze zur Verfügung stellen',
        },
        visualRepresentationOnImage: {
          title: 'Foto / Skizze',
        },
        dialog: {
          backButton: 'Zurück',
          goHomeButton: 'Zur Startseite',
          errorDialogTitle: 'Anlage kann nicht gebaut werden!',
          errorDialogMessage:
            'Bitte überprüfe, ob die Angaben korrekt sind. Andernfalls kann das Beratungsprotokoll nicht abgeschlossen werden.',
          initialTitle: 'Erstanalyse',
          initialMessage:
            'Die Erstanalyse dient dir dazu, zeitnah ein qualitativ gutes Angebot zu bekommen. Solltest du das komplette Beratungsprotokoll später ausfüllen, werden die Daten übernommen.',
          addEditItemsTitle: 'Elemente hinzufügen/bearbeiten',
          addEditItemsMessage:
            'Zum Hinzufügen von Elementen einfach die gewünschte Stelle antippen. Zum Verschieben das Element gedrückt halten. Zum Löschen das Element antippen und im Pop-Up die gewünschte Funktion wählen.',
          saveVisualRepresentation: 'Luftbild/Skizze hinterlegen',
          saveVisualRepresentationExplanation:
            'An dieser Stelle kannst du ein Luftbild, eine Drohnenaufnahme oder eine Skizze hinterlegen. Optional hast du die Möglichkeit, bereits alle sichtbaren Elemente zu ergänzen. Hierfür das gewünschte Element aus der oberen Leiste auswählen und dann auf dem hinterlegten Bild markieren. In den weiteren Schritten des Beratungsprotokolls kannst du die einzelnen Elemente ergänzen oder bearbeiten.',
          commentTitle: 'Kommentar - ',
          commentPlaceholder: 'Kommentar',
          consumption: {
            photographyTitle: 'Zählernummer scannen',
            photographyMessage:
              'Hier kannst du Fotos von den vorhandenen Stromzählern machen, woraufhin die Nummer gescannt wird und automatisch in das entsprechende Feld eingetragen wird. Bitte achte darauf, dass nur die Zählernummer zu sehen ist und diese gut erkennbar ist. Die Zählernummern sind wichtig für die Vollmachten bei den Netzbetreibern.',
          },
          roof: {
            mainBuildingTitle: 'Hauptgebäude & Nebengebäude',
            mainBuildingMessage:
              'Gib hier bitte zunächst das Hauptgebäude an, in dem Zähler und Speicher installiert werden sollen. Eventuelle Nebengebäude, z. B. eine Garage, sind bitte danach aufzuzählen.',
            brickMeasureTitle: 'Ziegeldeckmaß',
            brickMeasureMessage:
              'Die Breite des Ziegels ist die einfache Breite eines Dachziegels. Das Ziegeldeckmaß bezeichnet hingegen nur den sichtbaren Teil des Dachziegels, der nicht von anderen Dachziegeln verdeckt wird.',
            executionSubstructureTitle: 'Ausführung Unterkonstruktion',
            executionSubstructureImageLabelA:
              'Mögliche Art der Ausführung Nr.1',
            executionSubstructureImageLabelB:
              'Mögliche Art der Ausführung Nr.2',
            roofStructuresTitle: 'Dachaufbauten',
            roofStructuresMessage:
              'Hier kannst du Hinweise zu vorhandenen Dachaufbauten, wie Schornsteinen, Dachfenstern, Entlüftungsrohren etc., eingeben und mit einem Foto dokumentieren. Diese werden bei der Planung berücksichtigt.',
          },
          obstacle: {
            obstacleTitle: 'Hindernisse',
            obstacleMessage:
              'Bitte schau dir die Umgebung des Daches an und notiere mögliche Objekte, die zu einer Verschattung der Anlage führen könnten. Dazu zählen beispielsweise hohe Bäume, Nachbargebäude und Ähnliches.',
          },
          scaffold: {
            scaffoldObstacleTitle: 'Hindernisse',
            scaffoldObstacleMessage:
              'Hier werden die Hindernisse für die Aufstellung der Gerüste dokumentiert. Dies hilft den Montagepartnern, sich vorzubereiten.',
            publicWalkwayTitle: 'Öffentlicher Gehweg',
            publicWalkwayMessage:
              'Das obere Bild zeigt, dass ein zu naher öffentlicher Gehweg die Gerüststellung behindern könnte. In diesem Fall sind ggf. Genehmigungen erforderlich, die der Auftraggeber einholen muss.',
          },
          energyStorageAndMeter: {
            spaceRequirementsTitle: 'Platzanforderungen Speicher',
            spaceRequirementsImageLabelA: 'Aufstellung',
            spaceRequirementsImageLabelB: 'Wandmontage',
            bondingBarTitle: 'Potentialausgleichsschiene',
          },
          connections: {
            hakPhotoDocumentationDialogTitle: 'Fotodokumentation HAK',
            hakPhotoDocumentationDialogText:
              'Bitte den Hausanschlusskasten, wenn möglich, offen fotografieren und so, dass die Sicherungsgrößen, mindestens 35 Ampere, erkennbar sind.',
          },
          deleteDialog: {
            description:
              'Nach dem Löschen können die Markierungen nicht mehr wiederhergestellt werden. Trotzdem fortfahren?',
            confirm: 'Markierungen löschen',
            cancel: 'Zurück',
            mode: {
              roof: 'Bist du sicher, dass du alle Dach-Markierungen löschen möchtest?',
              door: 'Bist du sicher, dass du alle Tür-Markierungen löschen möchtest?',
              scaffold:
                'Bist du sicher, dass du alle Gerüst-Markierungen löschen möchtest?',
              danger:
                'Bist du sicher, dass du alle Hindernis-Markierungen löschen möchtest?',
              truck:
                'Bist du sicher, dass du alle Anlieferzonen-Markierungen löschen möchtest?',
              wallbox:
                'Bist du sicher, dass du alle Wallbox-Markierungen löschen möchtest?',
            },
          },
        },
        buttons: {
          save: 'Speichern',
          done: 'Fertig',
          block: 'Abschließen',
          finishedAlready: 'Abgeschlossen',
        },
        snackBarSuccessMessage: 'Abschnitt erfolgreich abgeschlossen',
        snackBarFinalSuccessMessage:
          'Beratungsprotokoll erfolgreich abgeschlossen',
      },
      confirmationEmail: {
        title:
          'E-Mail-Adresse des Leads auswählen, an welchen die Terminbestätigung versendet werden soll:',
        noEmail: 'Keine E-Mail-Adresse vorhanden am Lead',
        confirmationToastText: 'Der Termin wurde angelegt!',
      },
      globalSearch: {
        searchMinLettersNeeded: 'mindestens 3 Buchstaben eingeben',
        searchResultsEmpty: 'keine Ergebnisse gefunden',
      },
      message: {
        title: 'Interne Nachricht an Planer',
        messageDetails: 'Notiz Details',
        published: 'Gesendet',
        planning: 'Projektplanung',
        messageToPlanner: 'Interne Nachricht an Planer',
        messageFromPlanner: 'Interne Nachricht vom Planer',
        created: 'Nachricht erfolgreich erstellt!',
      },
      countries: {
        AF: 'Afghanistan',
        AX: 'Åland',
        AL: 'Albanien',
        DZ: 'Algerien',
        AS: 'Amerikanisch-Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktis',
        AG: 'Antigua und Barbuda',
        AR: 'Argentinien',
        AM: 'Armenien',
        AW: 'Aruba',
        AU: 'Australien',
        AT: 'Österreich',
        AZ: 'Aserbaidschan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesch',
        BB: 'Barbados',
        BY: 'Weißrussland',
        BE: 'Belgien',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivien',
        BA: 'Bosnien und Herzegowina',
        BW: 'Botswana',
        BR: 'Brasilien',
        IO: 'Britisches Territorium im Indischen Ozean',
        BN: 'Brunei Darussalam',
        BG: 'Bulgarien',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Kambodscha',
        CM: 'Kamerun',
        CA: 'Kanada',
        CV: 'Kap Verde',
        KY: 'Kaimaninseln',
        CF: 'Zentralafrikanische Republik',
        TD: 'Tschad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Weihnachtsinsel',
        CC: 'Kokosinseln',
        CO: 'Kolumbien',
        KM: 'Komoren',
        CG: 'Republik Kongo',
        CD: 'Kongo',
        CK: 'Cookinseln',
        CR: 'Costa Rica',
        CI: 'Elfenbeinküste',
        HR: 'Kroatien',
        CU: 'Kuba',
        CY: 'Zypern',
        CZ: 'Tschechische Republik',
        DK: 'Dänemark',
        DJ: 'Dschibuti',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        EC: 'Ecuador',
        EG: 'Ägypten',
        SV: 'El Salvador',
        GQ: 'Äquatorialguinea',
        ER: 'Eritrea',
        EE: 'Estland',
        ET: 'Äthiopien',
        FK: 'Falklandinseln',
        FO: 'Färöer',
        FJ: 'Fidschi',
        FI: 'Finnland',
        FR: 'Frankreich',
        GF: 'Französisch-Guayana',
        PF: 'Französisch-Polynesien',
        GA: 'Gabun',
        GM: 'Gambia',
        GE: 'Georgien',
        DE: 'Deutschland',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Griechenland',
        GL: 'Grönland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        VA: 'Vatikanstadt',
        HN: 'Honduras',
        HK: 'Hongkong',
        HU: 'Ungarn',
        IS: 'Island',
        IN: 'Indien',
        ID: 'Indonesien',
        IR: 'Iran',
        IQ: 'Irak',
        IE: 'Irland',
        IM: 'Insel Man',
        IL: 'Israel',
        IT: 'Italien',
        JM: 'Jamaika',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordanien',
        KZ: 'Kasachstan',
        KE: 'Kenia',
        KI: 'Kiribati',
        KP: 'Nordkorea',
        KR: 'Südkorea',
        KW: 'Kuwait',
        KG: 'Kirgisistan',
        LA: 'Laos',
        LV: 'Lettland',
        LB: 'Libanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libyen',
        LI: 'Liechtenstein',
        LT: 'Litauen',
        LU: 'Luxemburg',
        MO: 'Macao',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Malediven',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshallinseln',
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexiko',
        FM: 'Mikronesien',
        MD: 'Moldawien',
        MC: 'Monaco',
        MN: 'Mongolei',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MA: 'Marokko',
        MZ: 'Mosambik',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Niederlande',
        NC: 'Neukaledonien',
        NZ: 'Neuseeland',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolkinsel',
        MP: 'Nördliche Marianen',
        NO: 'Norwegen',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua-Neuguinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippinen',
        PN: 'Pitcairninseln',
        PL: 'Polen',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Katar',
        RO: 'Rumänien',
        RU: 'Russische Föderation',
        RW: 'Ruanda',
        RE: 'Réunion',
        BL: 'Saint-Barthélemy',
        SH: 'St. Helena',
        KN: 'St. Kitts und Nevis',
        LC: 'St. Lucia',
        MF: 'Saint-Martin',
        PM: 'Saint-Pierre und Miquelon',
        VC: 'St. Vincent und die Grenadinen',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'São Tomé und Príncipe',
        SA: 'Saudi-Arabien',
        SN: 'Senegal',
        RS: 'Serbien',
        SC: 'Seychellen',
        SL: 'Sierra Leone',
        SG: 'Singapur',
        SK: 'Slowakei',
        SI: 'Slowenien',
        SB: 'Salomonen',
        SO: 'Somalia',
        ZA: 'Südafrika',
        SS: 'Südsudan',
        GS: 'Südgeorgien und die Südlichen Sandwichinseln',
        ES: 'Spanien',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard und Jan Mayen',
        SZ: 'Swasiland',
        SE: 'Schweden',
        CH: 'Schweiz',
        SY: 'Syrien, Arabische Republik',
        TW: 'Taiwan',
        TJ: 'Tadschikistan',
        TZ: 'Tansania, Vereinigte Republik',
        TH: 'Thailand',
        TL: 'Osttimor',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad und Tobago',
        TN: 'Tunesien',
        TR: 'Türkei',
        TM: 'Turkmenistan',
        TC: 'Turks- und Caicosinseln',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'Vereinigte Arabische Emirate',
        GB: 'Vereinigtes Königreich',
        US: 'Vereinigte Staaten von Amerika',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'Britische Jungferninseln',
        VI: 'Amerikanische Jungferninseln',
        WF: 'Wallis und Futuna',
        YE: 'Jemen',
        ZM: 'Sambia',
        ZW: 'Simbabwe',
      },
    },
  },
};
